(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
      return;
    }
    fn();
  }

  ready(function () {
    var root = document.querySelector('[data-feature="visualiser-v3-desktop"] .pdpv3d-root');
    if (!root || root.dataset.desktopVisualiserReady === 'true') return;
    root.classList.remove('pdpv3-fallback-ready');
    root.dataset.desktopVisualiserReady = 'true';
    root.removeAttribute('data-desktop-visualiser-mounted');
    var visualiserFirstExperimentEnabled = !!document.querySelector('[data-product-images][data-visualiser-first-experiment="true"]');
    var autoSlideReadyAt = Date.now() + 2200;
    var lastTrustedVisualiserInputAt = 0;

    document.addEventListener('pointerdown', function (event) {
      if (!event || !event.isTrusted) return;
      if (!isVisualiserInputIntent(event.target)) return;
      lastTrustedVisualiserInputAt = Date.now();
    }, true);

    document.addEventListener('keydown', function (event) {
      if (!event || !event.isTrusted) return;
      if (!isVisualiserInputIntent(document.activeElement)) return;
      lastTrustedVisualiserInputAt = Date.now();
    }, true);

    var els = {
      stage: root.querySelector('.pdpv3d-stage'),
      sceneImage: root.querySelector('.pdpv3d-scene-image'),
      artImage: root.querySelector('.pdpv3d-art-image'),
      agedOverlay: root.querySelector('.pdpv3d-aged-overlay'),
      compareGhost: root.querySelector('.pdpv3d-compare-ghost'),
      meta: root.querySelector('.pdpv3d-meta'),
      finishSwitch: root.querySelector('.pdpv3d-finish-switch'),
      toneSwitch: root.querySelector('.pdpv3d-tone-switch'),
      measureLineW: root.querySelector('.pdpv3d-measure-line--width'),
      measureLineH: root.querySelector('.pdpv3d-measure-line--height'),
      measureLabelW: root.querySelector('.pdpv3d-measure-label--width'),
      measureLabelH: root.querySelector('.pdpv3d-measure-label--height'),
      arButton: root.querySelector('#ar-lozenge-desktop'),
      zoomButton: root.querySelector('.pdpv3d-stage-zoom')
    };

    var PRODUCT_IMAGES = {
      landscape: root.dataset.imageLandscape || '',
      portrait: root.dataset.imagePortrait || '',
      square: root.dataset.imageSquare || '',
      fallback: root.dataset.imageFallback || ''
    };
    var AGED_OVERLAYS = parseAgedOverlays();
    var SCALE_BACKGROUND_IMAGE = root.dataset.scaleImage || '';
    var FIXED_FRAME_THICKNESS_PX = 7;
    var SOFA_TEST_SCALE_FACTOR = 0.56;
    var SOFA_TEST_LANDSCAPE_BOOST = 1.22;
    var SOFA_TEST_PORTRAIT_MAX_HEIGHT_CM = 150;
    var SOFA_TEST_PORTRAIT_HEIGHT_SCALE = 0.95;
    var SOFA_TEST_CENTER_Y_OFFSET_PX = -80;
    var EXACT_SCALE_REFERENCE_SOURCE_SIZE = 1024;
    var EXACT_SCALE_LEFT_BOUNDARY_PX = 130;
    var EXACT_SCALE_REFERENCE_TOP_PX = 100;
    var EXACT_SCALE_REFERENCE_BOTTOM_PX = 727;
    var EXACT_SCALE_REFERENCE_HEIGHT_CM = 200;
    var EXACT_SCENE_SOURCE_SIZE = 919;
    var EXACT_SCENE_TOP_PX = 84;
    var EXACT_SCENE_BOTTOM_INSET_PX = 224;
    var EXACT_SCENE_HEIGHT_PX = 611;
    var EXACT_SCENE_CENTER_PX = EXACT_SCENE_TOP_PX + (EXACT_SCENE_HEIGHT_PX / 2);
    var A_SERIES_SIZES_CM = {
      a0: { widthCm: 84.1, heightCm: 118.9 },
      a1: { widthCm: 59.4, heightCm: 84.1 },
      a2: { widthCm: 42.0, heightCm: 59.4 },
      a3: { widthCm: 29.7, heightCm: 42.0 },
      a4: { widthCm: 21.0, heightCm: 29.7 },
      a5: { widthCm: 14.8, heightCm: 21.0 },
      a6: { widthCm: 10.5, heightCm: 14.8 }
    };
    var FRAME_COLOR_MAP = {
      white: '#f6f2ea',
      black: '#141414',
      oak: '#d5b48a',
      'dark brown': '#6d4320',
      'antique gold': '#b89f63',
      'dark grey': '#4d4d4d',
      'dark gray': '#4d4d4d',
      'antique silver': '#6c6f73'
    };
    var SCENE_IMAGE_BOUNDS = {
      sofa: {
        sourceSize: 1024,
        top: 10,
        bottom: 479,
        left: 110,
        right: 110,
        centerX: 512,
        centerY: 277.5
      },
      blankwall: {
        sourceSize: 1024,
        top: 88,
        bottom: 132,
        left: 126,
        right: 126,
        centerX: 512,
        centerY: 490
      },
      gallery: {
        sourceSize: 1024,
        top: 150,
        bottom: 340,
        left: 320,
        right: 312,
        centerX: 520,
        centerY: 388
      },
      charcoal: {
        sourceSize: 1024,
        top: 90,
        bottom: 430,
        left: 220,
        right: 220,
        centerX: 512,
        centerY: 342
      }
    };

    var SCENES = {
      sofa: {
        type: root.dataset.sceneSofaImage ? 'image' : 'css',
        image: root.dataset.sceneSofaImage || ''
      },
      blankwall: {
        type: root.dataset.sceneBlankwallImage ? 'image' : 'css',
        image: root.dataset.sceneBlankwallImage || ''
      },
      gallery: {
        type: root.dataset.sceneGalleryImage ? 'image' : 'css',
        image: root.dataset.sceneGalleryImage || ''
      },
      charcoal: {
        type: root.dataset.sceneCharcoalImage ? 'image' : 'css',
        image: root.dataset.sceneCharcoalImage || ''
      }
    };
    var ENABLE_BLANKWALL_SCENE = String(root.dataset.enableBlankwallScene || '').toLowerCase() === 'true';
    if (!ENABLE_BLANKWALL_SCENE) delete SCENES.blankwall;

    function getUiLabel(key, fallback) {
      var dataKey = 'label' + key.charAt(0).toUpperCase() + key.slice(1);
      return root.dataset[dataKey] || fallback || '';
    }

    function escapeHtml(value) {
      return String(value || '').replace(/[&<>"']/g, function (char) {
        return {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;'
        }[char];
      });
    }

    var BLANKWALL_SCENE_THUMB = 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 360">' +
        '<defs>' +
          '<linearGradient id="bg" x1="0%" y1="0%" x2="100%" y2="0%">' +
            '<stop offset="0%" stop-color="#e7e1d6"/>' +
            '<stop offset="18%" stop-color="#f3efe8"/>' +
            '<stop offset="82%" stop-color="#f3efe8"/>' +
            '<stop offset="100%" stop-color="#e7e1d6"/>' +
          '</linearGradient>' +
        '</defs>' +
        '<rect width="360" height="360" fill="url(#bg)"/>' +
      '</svg>'
    );

    function syncSceneThumb(activeSceneImage) {
      if (visualiserFirstExperimentEnabled) return;
      var thumbItem = document.querySelector('.custom-product__thumb-item--visualiser');
      if (!thumbItem) return;

      var thumbLink = thumbItem.querySelector('.product__thumb');
      var thumbBg = thumbItem.querySelector('img[data-visualiser-thumb-srcset]');
      if (!thumbLink || !thumbBg) return;

      var sceneThumbSrc = activeSceneImage || '';
      if (!sceneThumbSrc && state.view === 'styled' && state.scene === 'blankwall') {
        sceneThumbSrc = BLANKWALL_SCENE_THUMB;
      }
      if (!sceneThumbSrc) {
        sceneThumbSrc = root.dataset.sceneSofaImage || root.dataset.scaleImage || root.dataset.sceneGalleryImage || root.dataset.sceneCharcoalImage || '';
      }
      if (!sceneThumbSrc) return;

      var sceneThumbSrcset = sceneThumbSrc.indexOf('data:image') === 0
        ? sceneThumbSrc
        : (sceneThumbSrc + ' 360w');

      var isSceneSynced = thumbLink.getAttribute('data-visualiser-scene-sync') === 'true';
      var sameThumbState =
        isSceneSynced &&
        thumbLink.getAttribute('href') === sceneThumbSrc &&
        thumbLink.getAttribute('data-visualiser-thumb-href') === sceneThumbSrc &&
        thumbBg.getAttribute('src') === sceneThumbSrc &&
        thumbBg.getAttribute('srcset') === sceneThumbSrcset &&
        thumbBg.getAttribute('data-visualiser-thumb-srcset') === sceneThumbSrcset;
      if (sameThumbState) return;

      thumbLink.setAttribute('href', sceneThumbSrc);
      thumbLink.setAttribute('data-visualiser-thumb-href', sceneThumbSrc);
      thumbLink.setAttribute('data-visualiser-scene-sync', 'true');
      thumbBg.setAttribute('src', sceneThumbSrc);
      thumbBg.setAttribute('srcset', sceneThumbSrcset);
      thumbBg.setAttribute('data-visualiser-thumb-srcset', sceneThumbSrcset);
      thumbBg.classList.add('lazyloaded');
      thumbBg.classList.remove('lazyload');
      thumbBg.classList.remove('lazyautosizes');
    }

    function syncThumbArtworkPlacement(artLeft, artTop, artWidth, artHeight, stageWidth, stageHeight) {
      if (visualiserFirstExperimentEnabled) return;
      var thumbItem = document.querySelector('.custom-product__thumb-item--visualiser');
      if (!thumbItem) return;

      var thumbArt = thumbItem.querySelector('.custom-product-landscape-img-thumb');
      if (!thumbArt) return;
      if (!Number.isFinite(artLeft) || !Number.isFinite(artTop) || !Number.isFinite(artWidth) || !Number.isFinite(artHeight)) return;
      if (!Number.isFinite(stageWidth) || !Number.isFinite(stageHeight) || stageWidth <= 0 || stageHeight <= 0) return;

      var centerXPct = (artLeft / stageWidth) * 100;
      var centerYPct = (artTop / stageHeight) * 100;
      var widthPct = (artWidth / stageWidth) * 100;
      var heightPct = (artHeight / stageHeight) * 100;

      var nextLeft = clamp(centerXPct, 0, 100) + '%';
      var nextTop = clamp(centerYPct, 0, 100) + '%';
      var nextWidth = clamp(widthPct, 8, 100) + '%';
      var nextHeight = clamp(heightPct, 8, 100) + '%';
      var nextTransform = 'translate(-50%, -50%)';

      if (thumbArt.style.getPropertyValue('--vthumb-left') !== nextLeft) thumbArt.style.setProperty('--vthumb-left', nextLeft);
      if (thumbArt.style.getPropertyValue('--vthumb-top') !== nextTop) thumbArt.style.setProperty('--vthumb-top', nextTop);
      if (thumbArt.style.getPropertyValue('--vthumb-width') !== nextWidth) thumbArt.style.setProperty('--vthumb-width', nextWidth);
      if (thumbArt.style.getPropertyValue('--vthumb-height') !== nextHeight) thumbArt.style.setProperty('--vthumb-height', nextHeight);
      if (thumbArt.style.getPropertyValue('--vthumb-transform') !== nextTransform) thumbArt.style.setProperty('--vthumb-transform', nextTransform);
    }

    function getSuperZoomManifestUrl() {
      var manifestEl = document.querySelector('[data-dzi-manifest]');
      if (manifestEl && manifestEl.getAttribute) return manifestEl.getAttribute('data-dzi-manifest');
      var viewerEl = document.querySelector('.dzi-viewer[data-manifest]');
      if (viewerEl && viewerEl.getAttribute) return viewerEl.getAttribute('data-manifest');
      return null;
    }

    function tryOpenSuperZoomFromVisualiser() {
      var manifestUrl = getSuperZoomManifestUrl();
      if (!manifestUrl || typeof window.openDziModal !== 'function') return false;
      try {
        window.openDziModal(manifestUrl);
        return true;
      } catch (error) {
        return false;
      }
    }

    var defaultScene = String(root.dataset.defaultScene || root.dataset.scene || 'sofa').toLowerCase();
    if (!ENABLE_BLANKWALL_SCENE && defaultScene === 'blankwall') defaultScene = 'sofa';
    if (!SCENES[defaultScene]) defaultScene = 'sofa';

    var state = {
      scene: defaultScene,
      view: 'styled',
      sizeText: '',
      finishText: '',
      toneText: '',
      frameText: '',
      orientationText: '',
      orientation: 'portrait'
    };
    var visualiserSeen = {};
    var initStateRetryCount = 0;
    var initOrientationRetryCount = 0;
    var optionRerenderTimer = null;
    var pendingOffscreenRender = false;

    function pushVisualiserEvent(eventName, payload, dedupeKey) {
      if (!eventName) return;
      if (dedupeKey && visualiserSeen[dedupeKey]) return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({
        event: eventName,
        page_type: 'pdp',
        visualiser_type: 'desktop_v3'
      }, payload || {}));
      if (dedupeKey) visualiserSeen[dedupeKey] = true;
    }

    function setupVisualiserTracking() {
      if (!root) return;

      if ('IntersectionObserver' in window) {
        var viewObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            pushVisualiserEvent('visualiser_open', { trigger: 'viewport' }, 'desktop_open_once');
            viewObserver.disconnect();
          });
        }, { threshold: 0.35 });
        viewObserver.observe(root);
      } else {
        pushVisualiserEvent('visualiser_open', { trigger: 'fallback' }, 'desktop_open_once');
      }

      root.addEventListener('click', function (event) {
        var target = event.target;
        if (!target || !target.closest) return;

        if (target.closest('.pdpv3d-finish-btn')) {
          pushVisualiserEvent('visualiser_interaction', { control: 'finish', action: 'select' });
          return;
        }
        if (target.closest('.pdpv3d-tone-btn')) {
          pushVisualiserEvent('visualiser_interaction', { control: 'tone', action: 'select' });
          return;
        }
        if (target.closest('.pdpv3d-scene-btn, .pdpv3d-pill')) {
          pushVisualiserEvent('visualiser_interaction', { control: 'scene', action: 'select' });
        }
      }, { passive: true });
    }

    setupVisualiserTracking();

    function debounce(fn, wait) {
      var timeoutId;
      return function () {
        var args = arguments;
        clearTimeout(timeoutId);
        timeoutId = setTimeout(function () {
          fn.apply(null, args);
        }, wait);
      };
    }

    function normalizeImageSrcValue(value) {
      var src = String(value || '').trim();
      if (!src) return '';
      try {
        var resolved = new URL(src, window.location.origin);
        return resolved.origin + resolved.pathname + resolved.search;
      } catch (error) {
        return src.replace(/^https?:/, '').replace(/^\/\//, '//');
      }
    }

    function setImageSrcIfChanged(img, nextSrc) {
      if (!img || !nextSrc) return false;
      var nextNorm = normalizeImageSrcValue(nextSrc);
      if (!nextNorm) return false;
      var currentNorm = normalizeImageSrcValue(
        img.getAttribute('src') || img.currentSrc || img.src || ''
      );
      if (currentNorm === nextNorm) return false;
      img.src = nextSrc;
      return true;
    }

    function scheduleOptionRerender() {
      if (optionRerenderTimer) window.clearTimeout(optionRerenderTimer);
      optionRerenderTimer = window.setTimeout(function () {
        optionRerenderTimer = null;
        requestRender();
      }, 110);
    }

    function clamp(num, min, max) {
      return Math.min(Math.max(num, min), max);
    }

    function lerp(min, max, t) {
      return min + (max - min) * t;
    }

    function normaliseRange(value, min, max) {
      if (!Number.isFinite(value)) return 0;
      if (max <= min) return 0;
      return clamp((value - min) / (max - min), 0, 1);
    }

    function getCheckedInput(selector) {
      return document.querySelector(selector + ' input[type="radio"]:checked');
    }

    function getTextFromInput(input) {
      if (!input) return '';
      var label = document.querySelector('label[for="' + input.id + '"]');
      var labelTextNode = label ? label.querySelector('.variant__button-label-text') : null;
      if (labelTextNode && labelTextNode.textContent) {
        return labelTextNode.textContent.trim();
      }
      if (label) {
        var labelText = label.textContent || '';
        var priceNode = label.querySelector('[data-pdp-size-price], [data-pdp-finish-delta], .variant__button-price');
        var priceText = priceNode && priceNode.textContent ? priceNode.textContent.trim() : '';
        return (priceText ? labelText.replace(priceText, '') : labelText).trim();
      }
      return (input.value || '').trim();
    }

    function getSelectionDetails(input) {
      if (!input) {
        return { label: '', value: '' };
      }
      var label = document.querySelector('label[for="' + input.id + '"]');
      return {
        label: (label ? label.textContent : '').trim(),
        value: (input.value || '').trim()
      };
    }

    function getContainerSelectionDetails(containerSelector, inputName) {
      var field = document.querySelector(containerSelector);
      if (!field) return { label: '', value: '' };

      var inputSelector = inputName
        ? 'input[name="' + inputName.replace(/"/g, '\\"') + '"]'
        : 'input[type="radio"]';

      var checkedInput =
        field.querySelector(inputSelector + ':checked') ||
        document.querySelector(inputSelector + ':checked') ||
        field.querySelector('input[type="radio"]:checked');
      if (checkedInput) {
        return getSelectionDetails(checkedInput);
      }

      var selectedWrapper = field.querySelector(
        '.spb-productoptionswatchwrapper.selected,' +
        '.spb-productoptionswatchwrapper[aria-checked="true"],' +
        'label.selected,' +
        '[aria-checked="true"],' +
        '.is-selected,' +
        '.selected'
      );
      if (!selectedWrapper) {
        return { label: '', value: '' };
      }

      var wrapperInput = selectedWrapper.querySelector(inputSelector) || selectedWrapper.querySelector('input[type="radio"]');
      if (wrapperInput) {
        return getSelectionDetails(wrapperInput);
      }

      var labelText = (selectedWrapper.textContent || '').trim();
      return { label: labelText, value: labelText };
    }

    function getFirstSelectionDetails(candidates) {
      for (var i = 0; i < candidates.length; i += 1) {
        var candidate = candidates[i];
        if (candidate && (candidate.value || candidate.label)) {
          return candidate;
        }
      }
      return { label: '', value: '' };
    }

    function getSelectedSizeText() {
      var source = getSizeFieldset() || document;
      var checked = source.querySelector('input[type="radio"]:checked') || getCheckedInput('fieldset[name="Size"]');
      if (checked) {
        var checkedText = getTextFromInput(checked);
        if (checkedText && parseSizeTextToCm(checkedText)) return checkedText;
      }

      var selectedNode = source.querySelector(
        '.variant-input.is-selected[data-value],' +
        '.variant-input.selected[data-value],' +
        '.variant-input[aria-checked="true"][data-value],' +
        '.spb-productoptionswatchwrapper.selected[data-value],' +
        '.spb-productoptionswatchwrapper[aria-checked="true"][data-value]'
      );
      if (selectedNode) {
        var selectedValue = (selectedNode.getAttribute('data-value') || '').trim();
        if (selectedValue && parseSizeTextToCm(selectedValue)) return selectedValue;
      }

      var featuredSize = getSizeTextFromFeaturedSizeExperiment();
      if (featuredSize) return featuredSize;

      var stickySize = getSizeTextFromStickySummary();
      if (stickySize) return stickySize;

      var metaText = (els.meta && els.meta.textContent ? els.meta.textContent : '').trim();
      if (metaText && parseSizeTextToCm(metaText)) return metaText;

      return '';
    }

    function getSizeTextFromFeaturedSizeExperiment() {
      var selectors = [
        '.pdp-featured-size.is-active[data-size-value]',
        '.pdp-featured-size[aria-pressed="true"][data-size-value]',
        '.um-featured-size.is-active[data-size-value]'
      ];
      for (var i = 0; i < selectors.length; i += 1) {
        var node = document.querySelector(selectors[i]);
        if (!node || !node.getAttribute) continue;
        var value = String(node.getAttribute('data-size-value') || '').trim();
        if (value && parseSizeTextToCm(value)) return value;
      }
      return '';
    }

    function getFeaturedSizePreviewTargets() {
      var card = document.querySelector('[data-pdp-featured-sizes], .um-featured-sizes-card');
      if (!card) return [];
      var buttons = Array.from(card.querySelectorAll('[data-featured-size-key][data-size-value]'));
      var targets = buttons.map(function (button) {
        if (!button || button.disabled || button.hidden) return null;
        var value = String(button.getAttribute('data-size-value') || '').trim();
        var dims = parseSizeTextToCm(value);
        if (!value || !dims) return null;
        var input = findSizeInputForValue(value);
        if (!input || input.disabled) return null;
        var nameNode = button.querySelector('.pdp-featured-size__name');
        var rawLabel = (nameNode && nameNode.textContent ? nameNode.textContent : button.getAttribute('data-featured-size-key') || '').trim();
        if (!rawLabel || rawLabel.toLowerCase() === 'selected') return null;
        return {
          key: button.getAttribute('data-featured-size-key') || '',
          label: 'Preview ' + rawLabel,
          target: {
            input: input,
            value: value,
            dims: dims,
            area: dims.widthCm * dims.heightCm
          }
        };
      }).filter(Boolean);

      targets.sort(function (a, b) {
        return a.target.area - b.target.area;
      });
      return targets;
    }

    function findSizeInputForValue(value) {
      var normalizedTarget = normalizeSizeValue(value);
      if (!normalizedTarget) return null;
      var options = getSizeOptionNodes();
      for (var i = 0; i < options.length; i += 1) {
        var option = options[i];
        if (normalizeSizeValue(option.value) === normalizedTarget) return option.input;
      }
      return null;
    }

    function getSizeTextFromStickySummary() {
      var selectors = [
        '[js-product="stickyAddToCartVariant"]',
        '.sticky-add-to-cart__variant',
        '.pdp-atc-selection-line',
        '.custom-product-single__sticky'
      ];

      for (var i = 0; i < selectors.length; i += 1) {
        var el = document.querySelector(selectors[i]);
        var text = (el && el.textContent ? el.textContent : '').trim();
        if (!text) continue;
        if (parseSizeTextToCm(text)) return text;
      }

      return '';
    }

    function getSizeFieldset() {
      function isUsableFieldset(fieldset) {
        if (!fieldset) return false;
        if (fieldset.closest('[aria-hidden="true"], .hidden, [hidden]')) return false;
        return fieldset.offsetParent !== null;
      }

      var preferredSection = document.querySelector('.pdp-opt.pdp-opt--size, [data-pdp-pricing-size-section], [data-pdp-pricing-finish-first-size-slot]');
      if (preferredSection) {
        var preferredFieldset = preferredSection.querySelector('.variant-input-wrap[data-handle="size"], fieldset[data-handle="size"], fieldset[name="Size"]');
        if (isUsableFieldset(preferredFieldset)) return preferredFieldset;
      }

      var checked = getCheckedInput('fieldset[name="Size"]');
      var source = checked && checked.closest('.variant-input-wrap[data-handle="size"], fieldset[data-handle="size"], fieldset[name="Size"]');
      if (isUsableFieldset(source)) return source;

      var fieldsets = Array.from(document.querySelectorAll('.variant-input-wrap[data-handle="size"], fieldset[data-handle="size"], fieldset[name="Size"]')).filter(isUsableFieldset);

      return fieldsets.length ? fieldsets[0] : null;
    }

    function getSizeOptionNodes() {
      var source = getSizeFieldset() || document;
      return Array.from(source.querySelectorAll('.variant-input[data-value]')).map(function (node) {
        var input = node.querySelector('input[type="radio"]');
        return {
          node: node,
          input: input,
          value: ((node && node.getAttribute('data-value')) || input.value || '').trim()
        };
      }).filter(function (item) {
        return item.node && item.input && item.value;
      });
    }

    function scrollSizeFieldsetIntoView() {
      function openNearestDetails(node) {
        var current = node;
        while (current && current !== document.body) {
          if (current.tagName === 'DETAILS' && !current.open) {
            current.open = true;
          }
          current = current.parentElement;
        }
      }

      var preferredSizeSection = document.querySelector('.pdp-opt.pdp-opt--size');
      var source = preferredSizeSection || getSizeFieldset();
      var wrapper = source && (source.closest('.pdp-opt.pdp-opt--size, .variant-wrapper') || source);

      if (!wrapper) {
        var changeLink = document.getElementById('pdp-price-change');
        if (changeLink && typeof changeLink.click === 'function') {
          changeLink.click();
        }
        return;
      }

      openNearestDetails(wrapper);
      wrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });

      window.setTimeout(function () {
        var focusTarget = wrapper.querySelector('input[type="radio"]:checked, input[type="radio"], button, [tabindex]:not([tabindex="-1"])');
        if (focusTarget && typeof focusTarget.focus === 'function') {
          focusTarget.focus({ preventScroll: true });
        }
      }, 260);
    }

    function getNonASizeCandidates() {
      return getSizeOptionNodes().map(function (item) {
        var input = item.input;
        var value = item.value;
        var dims = parseSizeTextToCm(value);
        return {
          node: item.node,
          input: input,
          value: value,
          dims: dims,
          area: dims ? (dims.widthCm * dims.heightCm) : 0
        };
      }).filter(function (candidate) {
        return candidate.input && !candidate.input.disabled && candidate.dims && !isASize(candidate.value);
      });
    }

    function normalizeSizeValue(text) {
      return String(text || '')
        .toLowerCase()
        .replace(/\s+/g, '')
        .replace(/×/g, 'x')
        .replace(/"/g, 'in')
        .trim();
    }

    function getNamedTierTarget(name) {
      var candidates = getNonASizeCandidates();
      if (!candidates.length) return null;

      if (name === 'gallery') {
        candidates.sort(function (a, b) {
          return a.area - b.area;
        });
        return candidates[candidates.length - 1] || null;
      }

      var isSquareClassic = name === 'classic' && state.orientation === 'square';
      var isSquareStatement = name === 'statement' && state.orientation === 'square';
      var targetDimsList = name === 'classic'
        ? (isSquareClassic
          ? [{ widthCm: 45, heightCm: 45 }]
          : [{ widthCm: 45, heightCm: 60 }])
        : isSquareStatement
          ? [{ widthCm: 90, heightCm: 90 }]
          : [
          { widthCm: 60, heightCm: 90 },
          { widthCm: 60, heightCm: 80 },
          { widthCm: 60, heightCm: 75 }
        ];
      var aliases = name === 'classic'
        ? (isSquareClassic ? ['45x45cm', '18x18in'] : ['45x60cm', '18x24in'])
        : isSquareStatement
          ? ['90x90cm', '36x36in']
          : ['60x90cm', '60x80cm', '60x75cm', '24x36in', '24x32in', '24x30in'];

      var exact = candidates.find(function (candidate) {
        var normalized = normalizeSizeValue(candidate.value);
        return aliases.some(function (alias) {
          return normalized.indexOf(alias) !== -1;
        });
      });
      if (exact) return exact;

      var targetAreas = targetDimsList.map(function (targetDims) {
        return targetDims.widthCm * targetDims.heightCm;
      });
      var largestTargetArea = Math.max.apply(Math, targetAreas);
      var eligible = candidates.filter(function (candidate) {
        if (isSquareClassic || isSquareStatement) {
          var side = Math.max(candidate.dims.widthCm, candidate.dims.heightCm);
          var isSquare = Math.abs(candidate.dims.widthCm - candidate.dims.heightCm) < 0.75;
          var minSide = isSquareClassic ? 43 : 86;
          if (!isSquare || side < minSide) return false;
        }
        return candidate.area <= largestTargetArea + 0.5;
      });
      if (!eligible.length) return null;

      eligible.sort(function (a, b) {
        var aDiff = Math.min.apply(Math, targetAreas.map(function (targetArea) {
          return Math.abs(a.area - targetArea);
        }));
        var bDiff = Math.min.apply(Math, targetAreas.map(function (targetArea) {
          return Math.abs(b.area - targetArea);
        }));
        var diff = aDiff - bDiff;
        if (diff !== 0) return diff;
        return a.area - b.area;
      });
      return eligible[0] || null;
    }

    function getTierPreviewTarget() {
      var currentValue = getSelectedSizeText();
      if (!currentValue) {
        var current = getCheckedInput('fieldset[name="Size"]');
        currentValue = current ? (current.value || '') : '';
      }
      var currentDims = parseSizeTextToCm(currentValue || state.sizeText);
      var currentArea = currentDims ? (currentDims.widthCm * currentDims.heightCm) : 0;
      var tiers = getFeaturedSizePreviewTargets();
      var fallbackTiers = [
        { key: 'classic', label: 'Preview Classic', target: getNamedTierTarget('classic') },
        { key: 'statement', label: 'Preview Statement', target: getNamedTierTarget('statement') },
        { key: 'gallery', label: 'Preview Gallery', target: getNamedTierTarget('gallery') }
      ];
      if (!tiers.length) {
        tiers = fallbackTiers;
      } else {
        fallbackTiers.forEach(function (fallbackTier) {
          if (!fallbackTier || !fallbackTier.target || !fallbackTier.target.input) return;
          var hasTier = tiers.some(function (tier) {
            return tier.key === fallbackTier.key ||
              (tier.target && tier.target.input === fallbackTier.target.input);
          });
          if (!hasTier) tiers.push(fallbackTier);
        });
      }
      tiers = tiers.filter(function (tier) {
        return tier.target && tier.target.input;
      });

      tiers.sort(function (a, b) {
        return (a.target.area || 0) - (b.target.area || 0);
      });

      var seen = [];
      tiers = tiers.filter(function (tier) {
        if (seen.indexOf(tier.target.input) !== -1) return false;
        seen.push(tier.target.input);
        return true;
      });

      for (var i = 0; i < tiers.length; i += 1) {
        var tier = tiers[i];
        if (tier.target.input.checked) continue;
        if (tier.target.area > currentArea + 0.5) {
          return tier;
        }
      }

      return null;
    }

    function activateSizeInput(input, options) {
      if (!input || input.disabled) return;
      var opts = options || {};
      var preventLabelClick = opts.preventLabelClick === true;
      var label = input.id ? document.querySelector('label[for="' + input.id + '"]') : null;
      if (label && !preventLabelClick) {
        label.click();
        return;
      }
      input.checked = true;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('click', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function getAllowedFinishKeys() {
      return [
        'map',
        'artprint',
        'framedmap',
        'framedartprint',
        'framedcanvasmap',
        'framedcanvas'
      ];
    }

    function getFinishFamily(key) {
      if (key === 'map' || key === 'artprint') return 'print';
      if (key === 'framedmap' || key === 'framedartprint') return 'framed';
      if (key === 'framedcanvasmap' || key === 'framedcanvas') return 'canvas';
      return '';
    }

    function getFinishFamilyLabel(family, grouped) {
      var printKey = grouped && grouped.print ? grouped.print.key : '';
      var group = grouped && grouped[family];
      var optionLabel = group && group.option ? group.option.label : '';
      if (optionLabel) return optionLabel;

      if (family === 'print') {
        return printKey === 'map' ? 'Map' : 'Art Print';
      }

      if (family === 'framed') {
        return printKey === 'map' ? 'Framed Map' : 'Framed Print';
      }

      if (family === 'canvas') return 'Canvas';
      return '';
    }

    function sanitizeFinishLabel(text) {
      var label = String(text || '').replace(/\s+/g, ' ').trim();
      if (!label) return '';
      label = label.replace(/from\s*[\£\$\€]\s*[\d,\.\s]+$/i, '').trim();
      label = label.replace(/[\£\$\€]\s*[\d,\.\s]+$/i, '').trim();
      label = label.replace(/from$/i, '').trim();
      return label;
    }

    function normalizeFinishOption(text) {
      var normalized = String(text || '')
        .toLowerCase()
        .replace(/&/g, 'and')
        .replace(/[^a-z0-9]+/g, '')
        .trim();
      if (normalized === 'pushpinmap') return 'map';
      if (normalized === 'framedpushpinmap') return 'framedmap';
      return normalized;
    }

    function getVisibleFinishFieldsets() {
      return Array.from(document.querySelectorAll(
        '.variant-wrapper[data-handle="finish"] .variant-input-wrap,' +
        '.variant-input-wrap[data-handle="finish"],' +
        'fieldset[name="Finish"],' +
        'fieldset[name="Finition"]'
      )).filter(function (fieldset) {
        if (!fieldset) return false;
        if (fieldset.closest('[aria-hidden="true"], .hidden, [hidden]')) return false;
        return fieldset.offsetParent !== null;
      });
    }

    function getFinishOptionNodesFromSource(source) {
      if (!source) return [];

      return Array.from(source.querySelectorAll('.variant-input')).map(function (node) {
        var input = node.querySelector('input[type="radio"]');
        var label = input && input.id ? source.querySelector('label[for="' + input.id + '"]') : null;
        var labelTextNode = label ? label.querySelector('.variant__button-label-text') : null;
        var localizedLabel =
          (input && input.dataset ? input.dataset.localizedDisplayLabel : '') ||
          (node && node.getAttribute('data-localized-display-label')) ||
          (label && label.dataset ? label.dataset.localizedDisplayLabel : '') ||
          '';
        var labelText = sanitizeFinishLabel(
          localizedLabel ||
          (input && input.dataset ? input.dataset.displayLabel : '') ||
          (labelTextNode && labelTextNode.textContent) ||
          (label && label.textContent) ||
          (input && input.value) ||
          ''
        );
        var valueText = ((node && node.getAttribute('data-value')) || (input && input.value) || '').replace(/\s+/g, ' ').trim();
        return {
          node: node,
          input: input,
          value: valueText,
          label: labelText
        };
      }).filter(function (item) {
        return item.input && item.value;
      });
    }

    function getFinishFieldset() {
      var fieldsets = getVisibleFinishFieldsets();
      if (!fieldsets.length) return null;

      var allowed = getAllowedFinishKeys();
      var checkedSource = fieldsets.find(function (fieldset) {
        return fieldset.querySelector('input[type="radio"]:checked');
      });
      if (checkedSource) return checkedSource;

      var exactSource = fieldsets.find(function (fieldset) {
        var options = getFinishOptionNodesFromSource(fieldset);
        return options.length >= 2 && options.every(function (option) {
          return allowed.indexOf(normalizeFinishOption(option.value || option.label)) !== -1;
        });
      });

      return exactSource || fieldsets[0];
    }

    function getSelectedFinishText() {
      var source = getFinishFieldset();
      if (!source) return '';

      var selected = source.querySelector('input[type="radio"]:checked');
      if (!selected) return '';

      var node = selected.closest('.variant-input');
      return (((node && node.getAttribute('data-value')) || selected.value) || '').replace(/\s+/g, ' ').trim();
    }

    function getFinishOptionNodes() {
      return getFinishOptionNodesFromSource(getFinishFieldset());
    }

    function holdStickyOpen() {
      window.__pdpv3HoldStickyUntil = Date.now() + 2500;
    }

    function getFinishSwitchItems() {
      var options = getFinishOptionNodes();
      var allowed = getAllowedFinishKeys();
      var safe = options.length >= 2 && options.every(function (option) {
        return allowed.indexOf(normalizeFinishOption(option.value || option.label)) !== -1;
      });

      if (!safe) return [];

      var grouped = {};
      options.forEach(function (option) {
        var key = normalizeFinishOption(option.value || option.label);
        var family = getFinishFamily(key);
        if (!family) return;
        if (!grouped[family]) {
          grouped[family] = {
            family: family,
            key: key,
            option: option
          };
        }
        if (option.input && option.input.checked) {
          grouped[family].option = option;
        }
      });

      return ['print', 'framed', 'canvas'].map(function (family) {
        if (!grouped[family]) return null;
        grouped[family].label = getFinishFamilyLabel(family, grouped);
        return grouped[family];
      }).filter(Boolean);
    }

    function syncFinishSwitch() {
      if (!els.finishSwitch) return;

      var items = getFinishSwitchItems();
      if (items.length < 2) {
        els.finishSwitch.hidden = true;
        els.finishSwitch.style.display = 'none';
        els.finishSwitch.innerHTML = '';
        return;
      }

      var selected = items.find(function (item) {
        return item.option && item.option.input && item.option.input.checked;
      });

      els.finishSwitch.hidden = false;
      els.finishSwitch.style.display = 'inline-flex';
      els.finishSwitch.innerHTML = items.map(function (item) {
        var activeClass = selected && selected.family === item.family ? ' is-active' : '';
        return '<button type="button" class="pdpv3d-finish-btn' + activeClass + '" data-finish-input-id="' + escapeHtml(item.option.input.id) + '" aria-pressed="' + (activeClass ? 'true' : 'false') + '">' + escapeHtml(item.label) + '</button>';
      }).join('');

      els.finishSwitch.querySelectorAll('[data-finish-input-id]').forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          holdStickyOpen();
          window.__pdpv3SuppressAutoSlideUntil = Date.now() + 900;
          window.__pdpv3SuppressStickyRedirectUntil = Date.now() + 1200;
          var inputId = button.getAttribute('data-finish-input-id');
          var target = inputId ? document.getElementById(inputId) : null;
          if (!target) return;
          target.checked = true;
          target.dispatchEvent(new Event('input', { bubbles: true }));
          target.dispatchEvent(new Event('click', { bubbles: true }));
          target.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    }

    function getVisibleToneContainers() {
      var proxyToneActive = !!document.querySelector('[data-pdp-aged-tone-proxy]');
      return Array.from(document.querySelectorAll(
        'div.option_colour_tone, .option_colour_tone'
      )).filter(function (container) {
        if (!container) return false;
        if (container.closest('[aria-hidden="true"], .hidden, [hidden]')) return false;
        return proxyToneActive || container.offsetParent !== null;
      });
    }

    function normalizeToneOption(text) {
      return String(text || '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '')
        .trim();
    }

    function getToneDisplayLabel(key, fallback) {
      if (key === 'original') return getUiLabel('toneOriginal', fallback || 'Original');
      if (key === 'aged') return getUiLabel('toneAged', fallback || 'Aged');
      return fallback || '';
    }

    function getToneOptionNodesFromSource(source) {
      if (!source) return [];

      return Array.from(source.querySelectorAll('input[name="properties[Colour tone]"]')).map(function (input) {
        var label = input.id ? document.querySelector('label[for="' + input.id + '"]') : null;
        var trigger = label || input.closest('label') || input.closest('.spb-productoptionswatchwrapper') || input.parentElement;
        var labelText = ((label && label.textContent) || input.value || '').replace(/\s+/g, ' ').trim();
        var valueText = (input.value || '').replace(/\s+/g, ' ').trim();
        return {
          input: input,
          label: labelText,
          value: valueText,
          key: normalizeToneOption(valueText || labelText),
          trigger: trigger
        };
      }).filter(function (item) {
        return item.input && item.key;
      });
    }

    function getToneSource() {
      var containers = getVisibleToneContainers();
      if (!containers.length) return null;
      return containers[0];
    }

    function getToneSwitchItems() {
      var source = getToneSource();
      var options = getToneOptionNodesFromSource(source);
      var keyed = {};

      options.forEach(function (option) {
        if (option.key.indexOf('original') !== -1) keyed.original = option;
        if (option.key.indexOf('aged') !== -1) keyed.aged = option;
      });

      return ['original', 'aged'].map(function (key) {
        if (!keyed[key]) return null;
        return {
          key: key,
          label: getToneDisplayLabel(key, keyed[key].label),
          input: keyed[key].input,
          trigger: keyed[key].trigger
        };
      }).filter(Boolean);
    }

    function syncToneSwitch() {
      if (!els.toneSwitch) return;

      var items = getToneSwitchItems();
      if (items.length < 2) {
        els.toneSwitch.hidden = true;
        els.toneSwitch.style.display = 'none';
        els.toneSwitch.innerHTML = '';
        return;
      }

      els.toneSwitch.hidden = false;
      els.toneSwitch.style.display = 'inline-flex';
      els.toneSwitch.classList.add('notranslate');
      els.toneSwitch.setAttribute('translate', 'no');
      els.toneSwitch.innerHTML = items.map(function (item) {
        var activeClass = item.input.checked ? ' is-active' : '';
        return '<button type="button" class="pdpv3d-tone-btn' + activeClass + '" data-tone-index="' + escapeHtml(item.key) + '" aria-pressed="' + (item.input.checked ? 'true' : 'false') + '">' + escapeHtml(item.label) + '</button>';
      }).join('');

      els.toneSwitch.querySelectorAll('[data-tone-index]').forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          holdStickyOpen();
          window.__pdpv3SuppressStickyRedirectUntil = Date.now() + 1200;
          var toneKey = button.getAttribute('data-tone-index');
          var item = items.find(function (entry) { return entry.key === toneKey; });
          var target = item && item.input ? item.input : null;
          if (!target) return;
          target.checked = true;
          target.dispatchEvent(new Event('input', { bubbles: true }));
          target.dispatchEvent(new Event('click', { bubbles: true }));
          target.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    }

    function getSelectedToneText() {
      var selection = getFirstSelectionDetails([
        getContainerSelectionDetails('div.option_colour_tone', 'properties[Colour tone]'),
        getContainerSelectionDetails('.option_colour_tone', 'properties[Colour tone]')
      ]);
      return [selection.value, selection.label].filter(Boolean).join(' ').trim();
    }

    function getSelectedFrameText() {
      var selection = getFirstSelectionDetails([
        getContainerSelectionDetails('div.option_frame_colour_new', 'properties[Frame colour]'),
        getContainerSelectionDetails('.option_frame_colour_new', 'properties[Frame colour]'),
        getContainerSelectionDetails('.option_frame_colour', 'properties[Frame colour]'),
        getContainerSelectionDetails('.option_frame_colour_canvas', 'properties[Frame colour]')
      ]);
      return [selection.value, selection.label].filter(Boolean).join(' ').trim();
    }

    function getSelectedOrientationText() {
      return getTextFromInput(getCheckedInput('fieldset[name="Portrait or landscape?"]'));
    }

    function isASize(text) {
      return /^a\d+(\b|$)/i.test(String(text || '').trim());
    }

    function getDisplayUnitFromLabel(text) {
      var raw = (text || '').toLowerCase();
      if (/\bcm\b/.test(raw)) return 'cm';
      if (/\bmm\b/.test(raw)) return 'mm';
      if (/\bin\b/.test(raw) || /["]/.test(raw)) return 'in';
      return 'cm';
    }

    function getPreferredRawSizeMatch(raw) {
      if (!raw) return null;
      var regex = /(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)(?:\s*)(mm|cm|in)?/ig;
      var matches = [];
      var match;
      while ((match = regex.exec(raw)) !== null) {
        matches.push({
          width: match[1],
          height: match[2],
          unit: String(match[3] || '').toLowerCase()
        });
      }
      if (!matches.length) return null;

      for (var i = 0; i < matches.length; i += 1) {
        if (matches[i].unit === 'cm') return matches[i];
      }
      for (var j = 0; j < matches.length; j += 1) {
        if (matches[j].unit === 'mm') return matches[j];
      }
      for (var k = 0; k < matches.length; k += 1) {
        if (matches[k].unit === 'in') return matches[k];
      }
      return matches[0];
    }

    function parseSizeTextToCm(text) {
      var raw = (text || '').trim();
      if (!raw) return null;

      var compact = raw.toLowerCase().replace(/\s+/g, '');
      var aSeriesMatch = compact.match(/\ba([0-6])\b/);
      if (aSeriesMatch) {
        var aKey = 'a' + aSeriesMatch[1];
        if (A_SERIES_SIZES_CM[aKey]) {
          return {
            widthCm: A_SERIES_SIZES_CM[aKey].widthCm,
            heightCm: A_SERIES_SIZES_CM[aKey].heightCm,
            unit: 'mm'
          };
        }
      }

      var match = getPreferredRawSizeMatch(raw);
      if (!match) return null;

      var width = parseFloat(match.width);
      var height = parseFloat(match.height);
      var unit = match.unit || getDisplayUnitFromLabel(raw);

      if (unit === 'mm') {
        width /= 10;
        height /= 10;
      } else if (unit === 'in') {
        width *= 2.54;
        height *= 2.54;
      }

      return {
        widthCm: width,
        heightCm: height,
        unit: unit === 'mm' ? 'cm' : unit
      };
    }

    function formatSizeTextForMeta(rawText) {
      var raw = (rawText || '').trim();
      if (!raw) return '-';

      function formatMetaNumber(value) {
        var num = Number(value);
        if (!isFinite(num)) return String(value || '');
        if (Math.abs(num - Math.round(num)) < 0.000001) return String(Math.round(num));
        return String(num).replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.0+$/, '');
      }

      var compact = raw.toLowerCase().replace(/\s+/g, '');
      var aSeriesMatch = compact.match(/\ba([0-6])\b/);
      if (aSeriesMatch) {
        var aKey = 'a' + aSeriesMatch[1];
        var dims = A_SERIES_SIZES_CM[aKey];
        if (dims) {
          return aKey.toUpperCase() + ' (' + Math.round(dims.widthCm * 10) + 'x' + Math.round(dims.heightCm * 10) + 'mm)';
        }
      }

      var rawSizeMatch = getPreferredRawSizeMatch(raw);
      if (rawSizeMatch) {
        var widthValue = formatMetaNumber(rawSizeMatch.width);
        var heightValue = formatMetaNumber(rawSizeMatch.height);
        var unit = String(rawSizeMatch.unit || getDisplayUnitFromLabel(raw) || 'cm').toLowerCase();
        return widthValue + 'x' + heightValue + unit;
      }

      return raw.replace(/\s*x\s*/gi, 'x').replace(/\s+/g, '');
    }

    function getRawSizeDimsForMeta(rawText) {
      var raw = (rawText || '').trim();
      if (!raw) return null;

      var compact = raw.toLowerCase().replace(/\s+/g, '');
      var aSeriesMatch = compact.match(/\ba([0-6])\b/);
      if (aSeriesMatch) {
        var aKey = 'a' + aSeriesMatch[1];
        if (A_SERIES_SIZES_CM[aKey]) {
          return {
            widthCm: A_SERIES_SIZES_CM[aKey].widthCm,
            heightCm: A_SERIES_SIZES_CM[aKey].heightCm,
            unit: 'mm'
          };
        }
      }

      var match = getPreferredRawSizeMatch(raw);
      if (!match) return null;

      var width = parseFloat(match.width);
      var height = parseFloat(match.height);
      var unit = match.unit || getDisplayUnitFromLabel(raw);

      if (unit === 'mm') {
        width /= 10;
        height /= 10;
      } else if (unit === 'in') {
        width *= 2.54;
        height *= 2.54;
      }

      return {
        widthCm: width,
        heightCm: height,
        unit: unit
      };
    }

    function formatFramedSizeForMeta(rawText) {
      var rawDims = getRawSizeDimsForMeta(rawText);
      if (!rawDims) return '';
      var frameEachSideCm = rawDims.unit === 'in' ? 2.54 : 2;
      return formatDims(
        rawDims.widthCm + (frameEachSideCm * 2),
        rawDims.heightCm + (frameEachSideCm * 2),
        rawDims.unit
      );
    }

    function normaliseToneKey(toneText) {
      var key = (toneText || '').toLowerCase();
      if (document.querySelector('input[name="properties[Colour tone]"][value*="Aged"]:checked')) return 'aged';
      return key.indexOf('aged') !== -1 ? 'aged' : 'original';
    }

    function resolveFrameColor(frameText) {
      var key = (frameText || '').toLowerCase();
      if (!key) return '#181818';

      for (var mapKey in FRAME_COLOR_MAP) {
        if (Object.prototype.hasOwnProperty.call(FRAME_COLOR_MAP, mapKey) && key.indexOf(mapKey) !== -1) {
          return FRAME_COLOR_MAP[mapKey];
        }
      }

      return '#181818';
    }

    function inferOrientation(rawDimensions) {
      var fallbackSrc = PRODUCT_IMAGES.fallback || '';
      var dedicatedOrientations = [];

      ['landscape', 'portrait', 'square'].forEach(function (key) {
        var src = PRODUCT_IMAGES[key] || '';
        if (src && src !== fallbackSrc) {
          dedicatedOrientations.push(key);
        }
      });

      if (dedicatedOrientations.length === 1) {
        return dedicatedOrientations[0];
      }

      var hintedOrientation = getSlideOrientationHint();
      if (hintedOrientation) return hintedOrientation;

      var proxyRatio = getProxyImageAspectRatio();
      if (proxyRatio && Math.abs(proxyRatio - 1) > 0.04) {
        return proxyRatio > 1 ? 'landscape' : 'portrait';
      }

      if (els.artImage && els.artImage.naturalWidth && els.artImage.naturalHeight) {
        var ratio = els.artImage.naturalWidth / Math.max(els.artImage.naturalHeight, 1);
        if (ratio > 1.02) return 'landscape';
        if (ratio < 0.98) return 'portrait';
        return 'square';
      }

      if (rawDimensions && Math.abs(rawDimensions.widthCm - rawDimensions.heightCm) < 0.01) {
        return 'square';
      }
      if (rawDimensions && rawDimensions.widthCm > rawDimensions.heightCm) return 'landscape';
      if (rawDimensions && rawDimensions.heightCm > rawDimensions.widthCm) return 'portrait';
      return 'portrait';
    }

    function getSlideOrientationHint() {
      var slide = root && root.closest ? root.closest('.product-main-slide') : null;
      if (!slide || !slide.dataset) return '';

      var finishRaw = String(state.finishText || '').toLowerCase();
      var orderedHints = [];
      if (finishRaw.indexOf('fram') !== -1) {
        orderedHints.push(slide.dataset.mainProductImageFramedOrientation || '');
      } else {
        orderedHints.push(slide.dataset.mainProductImageUnframedOrientation || '');
      }
      orderedHints.push(slide.dataset.mainProductImageFramedOrientation || '');
      orderedHints.push(slide.dataset.mainProductImageUnframedOrientation || '');

      for (var i = 0; i < orderedHints.length; i += 1) {
        var value = String(orderedHints[i] || '').toLowerCase();
        if (value.indexOf('landscape') !== -1) return 'landscape';
        if (value.indexOf('portrait') !== -1) return 'portrait';
        if (value.indexOf('square') !== -1) return 'square';
      }

      return '';
    }

    function getProxyImageAspectRatio() {
      var proxyImage = root.closest('.product-main-slide') && root.closest('.product-main-slide').querySelector('.pdpv3-photoswipe-proxy');
      var proxyWidth = proxyImage ? Number(proxyImage.getAttribute('data-photoswipe-width')) : 0;
      var proxyHeight = proxyImage ? Number(proxyImage.getAttribute('data-photoswipe-height')) : 0;
      if (proxyWidth > 0 && proxyHeight > 0) {
        return proxyWidth / proxyHeight;
      }
      return 0;
    }

    function orientDims(dimensions, orientation) {
      if (!dimensions) return null;
      var width = dimensions.widthCm;
      var height = dimensions.heightCm;

      if (orientation === 'landscape' && height > width) {
        var widthSwap = width;
        width = height;
        height = widthSwap;
      }
      if (orientation === 'portrait' && width > height) {
        var heightSwap = width;
        width = height;
        height = heightSwap;
      }
      if (orientation === 'square') {
        var side = Math.min(width, height);
        width = side;
        height = side;
      }

      return { widthCm: width, heightCm: height, unit: dimensions.unit };
    }

    function formatValueForDisplay(value, unit) {
      if (!Number.isFinite(value)) return '-';
      if (unit === 'mm') {
        return String(Math.round(value * 10));
      }
      if (unit === 'in') {
        var inches = value / 2.54;
        var roundedInches = Math.round(inches * 10) / 10;
        return Number.isInteger(roundedInches) ? String(roundedInches) : roundedInches.toFixed(1);
      }
      var roundedCm = Math.round(value * 10) / 10;
      return Number.isInteger(roundedCm) ? String(roundedCm) : roundedCm.toFixed(1);
    }

    function formatDims(widthCm, heightCm, unit) {
      return formatValueForDisplay(widthCm, unit) + 'x' + formatValueForDisplay(heightCm, unit) + unit;
    }

    function getFrameThicknessCm(unit) {
      if (unit === 'mm') return 2;
      return unit === 'in' ? 2.54 : 2;
    }

    function getOuterDims(dimensions, finishKey) {
      if (!dimensions) return null;
      if (finishKey !== 'framed') return dimensions;

      var frameEachSideCm = dimensions.unit === 'in' ? 2.54 : 2;
      return {
        widthCm: dimensions.widthCm + (frameEachSideCm * 2),
        heightCm: dimensions.heightCm + (frameEachSideCm * 2),
        unit: dimensions.unit
      };
    }

    function getSourceImageAspectRatio() {
      if (els.artImage && els.artImage.naturalWidth && els.artImage.naturalHeight) {
        return els.artImage.naturalWidth / els.artImage.naturalHeight;
      }
      if (state.orientation === 'landscape') return 4 / 3;
      if (state.orientation === 'square') return 1;
      return 0.75;
    }

    function getProxyDimensionsCm(selectedDimensions, imageRatio) {
      if (!selectedDimensions || !imageRatio) return null;

      if (selectedDimensions.heightCm >= selectedDimensions.widthCm) {
        return {
          widthCm: selectedDimensions.heightCm * imageRatio,
          heightCm: selectedDimensions.heightCm
        };
      }

      return {
        widthCm: selectedDimensions.widthCm,
        heightCm: selectedDimensions.widthCm / imageRatio
      };
    }

    function getOrientationFromRenderedRatio(imageRatio, fallbackDimensions) {
      if (imageRatio) {
        if (Math.abs(imageRatio - 1) < 0.02) return 'square';
        return imageRatio > 1 ? 'landscape' : 'portrait';
      }
      return inferOrientation(fallbackDimensions);
    }

    function getRenderBox(selectedDimensions, stageWidth, stageHeight, view, sceneKey, proxyDimensions) {
      var widthNorm = normaliseRange(selectedDimensions.widthCm, 30, 300);
      var heightNorm = normaliseRange(selectedDimensions.heightCm, 30, 200);

      if (view === 'styled') {
        if (sceneKey === 'sofa' && proxyDimensions) {
          var isPortrait = proxyDimensions.heightCm > proxyDimensions.widthCm * 1.05;
          var isLandscape = proxyDimensions.widthCm > proxyDimensions.heightCm * 1.05;

          if (isPortrait) {
            return {
              width: lerp(stageWidth * 0.19, stageWidth * 0.43, widthNorm),
              height: lerp(stageHeight * 0.24, stageHeight * 0.62, heightNorm)
            };
          }

          if (isLandscape) {
            return {
              width: lerp(stageWidth * 0.26, stageWidth * 0.64, widthNorm),
              height: lerp(stageHeight * 0.20, stageHeight * 0.52, heightNorm)
            };
          }

          return {
            width: lerp(stageWidth * 0.22, stageWidth * 0.52, widthNorm),
            height: lerp(stageHeight * 0.22, stageHeight * 0.58, heightNorm)
          };
        }

        return {
          width: lerp(stageWidth * 0.22, stageWidth * 0.66, widthNorm),
          height: lerp(stageHeight * 0.24, stageHeight * 0.70, heightNorm)
        };
      }

      return {
        width: lerp(stageWidth * 0.24, stageWidth * 0.90, widthNorm),
        height: lerp(stageHeight * 0.30, stageHeight * 0.88, heightNorm)
      };
    }

    function getArtPixels(proxyDimensions, selectedDimensions, stageWidth, stageHeight, view, sceneKey) {
      var renderBox = getRenderBox(selectedDimensions, stageWidth, stageHeight, view, sceneKey, proxyDimensions);
      var fit = Math.min(
        renderBox.width / Math.max(proxyDimensions.widthCm, 1),
        renderBox.height / Math.max(proxyDimensions.heightCm, 1)
      );

      return {
        width: Math.max(20, Math.round(proxyDimensions.widthCm * fit)),
        height: Math.max(20, Math.round(proxyDimensions.heightCm * fit))
      };
    }

    function getFrameThicknessPx(proxyDimensions, artPixels, unit) {
      if (!proxyDimensions || !artPixels) return 0;
      return FIXED_FRAME_THICKNESS_PX;
    }

    function getSceneImageBounds(sceneKey, stageWidth, stageHeight) {
      var config = SCENE_IMAGE_BOUNDS[sceneKey];
      if (!config) return null;

      var scale = Math.max(stageWidth / config.sourceSize, stageHeight / config.sourceSize);
      var renderedSize = config.sourceSize * scale;
      var offsetX = (stageWidth - renderedSize) / 2;
      var offsetY = (stageHeight - renderedSize) / 2;

      return {
        scale: scale,
        offsetX: offsetX,
        offsetY: offsetY,
        left: offsetX + (config.left * scale),
        top: offsetY + (config.top * scale),
        width: (config.sourceSize - config.left - config.right) * scale,
        height: (config.sourceSize - config.top - config.bottom) * scale
      };
    }

    function getStyledScenePlacement(sceneKey, proxyDimensions, selectedDimensions, stageWidth, stageHeight) {
      var config = SCENE_IMAGE_BOUNDS[sceneKey];
      var bounds = getSceneImageBounds(sceneKey, stageWidth, stageHeight);
      if (!bounds) return null;

      if (sceneKey === 'charcoal' && proxyDimensions) {
        var charcoalSafeWidth = Math.max(20, bounds.width);
        var charcoalSafeHeight = Math.max(20, bounds.height);
        var charcoalCenterX = config.centerX ? (bounds.offsetX + (config.centerX * bounds.scale)) : (bounds.left + (bounds.width / 2));
        var charcoalCenterY = config.centerY ? (bounds.offsetY + (config.centerY * bounds.scale)) : (bounds.top + (bounds.height / 2));
        var charcoalIsLandscape = proxyDimensions.widthCm > proxyDimensions.heightCm * 1.05;
        var charcoalIsPortrait = proxyDimensions.heightCm > proxyDimensions.widthCm * 1.05;
        var charcoalArtWidth;
        var charcoalArtHeight;

        if (charcoalIsPortrait) {
          var charcoalCappedPortraitHeightCm = Math.min(proxyDimensions.heightCm, SOFA_TEST_PORTRAIT_MAX_HEIGHT_CM);
          var charcoalPortraitPxPerCm = (charcoalSafeHeight * SOFA_TEST_PORTRAIT_HEIGHT_SCALE) / Math.max(SOFA_TEST_PORTRAIT_MAX_HEIGHT_CM, 1);
          charcoalArtHeight = Math.max(20, Math.round(charcoalCappedPortraitHeightCm * charcoalPortraitPxPerCm));
          charcoalArtWidth = Math.max(
            20,
            Math.round(charcoalArtHeight * (proxyDimensions.widthCm / Math.max(proxyDimensions.heightCm, 1)))
          );
        } else {
          var charcoalSceneScale = Math.min(stageWidth / EXACT_SCENE_SOURCE_SIZE, stageHeight / EXACT_SCENE_SOURCE_SIZE);
          var charcoalPxPerCm = charcoalSceneScale * (EXACT_SCENE_HEIGHT_PX / 200);
          charcoalArtWidth = Math.max(20, Math.round(proxyDimensions.widthCm * charcoalPxPerCm * SOFA_TEST_SCALE_FACTOR));
          charcoalArtHeight = Math.max(20, Math.round(proxyDimensions.heightCm * charcoalPxPerCm * SOFA_TEST_SCALE_FACTOR));

          if (charcoalIsLandscape) {
            charcoalArtWidth = Math.max(20, Math.round(charcoalArtWidth * SOFA_TEST_LANDSCAPE_BOOST));
            charcoalArtHeight = Math.max(20, Math.round(charcoalArtHeight * SOFA_TEST_LANDSCAPE_BOOST));
          }
        }

        if (charcoalArtWidth > charcoalSafeWidth || charcoalArtHeight > charcoalSafeHeight) {
          var charcoalSafeFit = Math.min(
            charcoalSafeWidth / Math.max(charcoalArtWidth, 1),
            charcoalSafeHeight / Math.max(charcoalArtHeight, 1)
          );
          charcoalArtWidth = Math.max(20, Math.round(charcoalArtWidth * charcoalSafeFit));
          charcoalArtHeight = Math.max(20, Math.round(charcoalArtHeight * charcoalSafeFit));
        }

        return {
          width: charcoalArtWidth,
          height: charcoalArtHeight,
          left: charcoalCenterX,
          top: charcoalCenterY
        };
      }

      var scale = bounds.scale;
      var centerX = config.centerX ? (bounds.offsetX + (config.centerX * scale)) : (bounds.left + (bounds.width / 2));
      var centerY = config.centerY ? (bounds.offsetY + (config.centerY * scale)) : (bounds.top + (bounds.height / 2));
      var maxWidthFromCenter = 2 * Math.min(centerX - bounds.left, (bounds.left + bounds.width) - centerX);
      var maxHeightFromCenter = 2 * Math.min(centerY - bounds.top, (bounds.top + bounds.height) - centerY);

      if (sceneKey === 'blankwall' && proxyDimensions) {
        var blankwallIsLandscape = proxyDimensions.widthCm > proxyDimensions.heightCm * 1.05;
        var blankwallIsPortrait = proxyDimensions.heightCm > proxyDimensions.widthCm * 1.05;
        var lockedBlankwallWidth = blankwallIsPortrait
          ? stageWidth
          : blankwallIsLandscape
            ? (stageWidth * 0.8)
            : (stageWidth * 0.84);
        var lockedBlankwallHeight = blankwallIsPortrait
          ? (stageHeight * 0.86)
          : blankwallIsLandscape
            ? stageHeight
            : (stageHeight * 0.84);
        var blankwallMaxWidthFromCenter = 2 * Math.min(centerX, stageWidth - centerX);
        var blankwallMaxHeightFromCenter = 2 * Math.min(centerY, stageHeight - centerY);
        var lockedBlankwallFit = Math.min(
          lockedBlankwallWidth / Math.max(proxyDimensions.widthCm, 1),
          lockedBlankwallHeight / Math.max(proxyDimensions.heightCm, 1),
          Math.max(20, blankwallMaxWidthFromCenter) / Math.max(proxyDimensions.widthCm, 1),
          Math.max(20, blankwallMaxHeightFromCenter) / Math.max(proxyDimensions.heightCm, 1)
        );
        return {
          width: Math.max(20, Math.round(proxyDimensions.widthCm * lockedBlankwallFit)),
          height: Math.max(20, Math.round(proxyDimensions.heightCm * lockedBlankwallFit)),
          left: centerX,
          top: centerY
        };
      }

      var widthNorm = normaliseRange(selectedDimensions.widthCm, 30, 300);
      var heightNorm = normaliseRange(selectedDimensions.heightCm, 30, 200);
      var minWidthFactor = sceneKey === 'gallery' ? 0.48 : 0.24;
      var minHeightFactor = sceneKey === 'gallery' ? 0.48 : 0.24;
      var maxWidthFactor = sceneKey === 'gallery' ? 1.06 : 0.98;
      var maxHeightFactor = sceneKey === 'gallery' ? 1.04 : 0.98;
      var preferredWidth = lerp(bounds.width * minWidthFactor, bounds.width * maxWidthFactor, widthNorm);
      var preferredHeight = lerp(bounds.height * minHeightFactor, bounds.height * maxHeightFactor, heightNorm);
      var fit = Math.min(
        preferredWidth / Math.max(proxyDimensions.widthCm, 1),
        preferredHeight / Math.max(proxyDimensions.heightCm, 1),
        Math.max(20, maxWidthFromCenter) / Math.max(proxyDimensions.widthCm, 1),
        Math.max(20, maxHeightFromCenter) / Math.max(proxyDimensions.heightCm, 1)
      );
      var artWidth = Math.max(20, Math.round(proxyDimensions.widthCm * fit));
      var artHeight = Math.max(20, Math.round(proxyDimensions.heightCm * fit));

      return {
        width: artWidth,
        height: artHeight,
        left: centerX,
        top: centerY
      };
    }

    function getExactScalePlacement(exactDimensions, proxyDimensions, stageWidth, stageHeight, finishKey) {
      if (!exactDimensions || !proxyDimensions) return null;

      var sceneScale = Math.min(
        stageWidth / EXACT_SCALE_REFERENCE_SOURCE_SIZE,
        stageHeight / EXACT_SCALE_REFERENCE_SOURCE_SIZE
      );
      var pxPerCm = sceneScale * (
        (EXACT_SCALE_REFERENCE_BOTTOM_PX - EXACT_SCALE_REFERENCE_TOP_PX) /
        EXACT_SCALE_REFERENCE_HEIGHT_CM
      );
      var exactBoxWidth = Math.max(20, exactDimensions.widthCm * pxPerCm);
      var exactBoxHeight = Math.max(20, exactDimensions.heightCm * pxPerCm);
      var artFit = Math.min(
        exactBoxWidth / Math.max(proxyDimensions.widthCm, 1),
        exactBoxHeight / Math.max(proxyDimensions.heightCm, 1)
      );
      var artWidth = Math.max(20, Math.round(proxyDimensions.widthCm * artFit));
      var artHeight = Math.max(20, Math.round(proxyDimensions.heightCm * artFit));
      var frameThicknessPx = finishKey === 'framed'
        ? getFrameThicknessPx(exactDimensions, { width: artWidth, height: artHeight }, exactDimensions.unit)
        : 0;
      var shellWidth = artWidth + (frameThicknessPx * 2);
      var shellHeight = artHeight + (frameThicknessPx * 2);
      var leftLimit = EXACT_SCALE_LEFT_BOUNDARY_PX * sceneScale;
      var topLimit = EXACT_SCALE_REFERENCE_TOP_PX * sceneScale;
      var bottomLimit = EXACT_SCALE_REFERENCE_BOTTOM_PX * sceneScale;
      var centerX = leftLimit + ((stageWidth - leftLimit) / 2);
      var centerY = topLimit + ((bottomLimit - topLimit) / 2);
      var artLeft = clamp(centerX, leftLimit + (shellWidth / 2), stageWidth - (shellWidth / 2));
      var artTop = clamp(centerY, topLimit + (shellHeight / 2), bottomLimit - (shellHeight / 2));

      return {
        width: artWidth,
        height: artHeight,
        left: artLeft,
        top: artTop
      };
    }

    function getSofaTestPlacement(proxyDimensions, stageWidth, stageHeight) {
      if (!proxyDimensions) return null;

      var bounds = getSceneImageBounds('sofa', stageWidth, stageHeight);
      if (!bounds) return null;

      var safeWidth = Math.max(20, bounds.width);
      var safeHeight = Math.max(20, bounds.height);
      var sofaConfig = SCENE_IMAGE_BOUNDS.sofa;
      var centerX = sofaConfig && sofaConfig.centerX
        ? (bounds.offsetX + (sofaConfig.centerX * bounds.scale))
        : (bounds.left + (bounds.width / 2));
      var centerY = sofaConfig && sofaConfig.centerY
        ? (bounds.offsetY + ((sofaConfig.centerY + SOFA_TEST_CENTER_Y_OFFSET_PX) * bounds.scale))
        : (bounds.top + (bounds.height / 2) + (SOFA_TEST_CENTER_Y_OFFSET_PX * bounds.scale));
      var isLandscape = proxyDimensions.widthCm > proxyDimensions.heightCm * 1.05;
      var isPortrait = proxyDimensions.heightCm > proxyDimensions.widthCm * 1.05;
      var isSquare = !isPortrait && !isLandscape;
      var artWidth;
      var artHeight;

      if (isPortrait) {
        // Portrait in the test scene now scales directly to the sofa wall box,
        // instead of inheriting the exact-size placement and shrinking from there.
        var cappedPortraitHeightCm = Math.min(proxyDimensions.heightCm, SOFA_TEST_PORTRAIT_MAX_HEIGHT_CM);
        var portraitPxPerCm = (safeHeight * SOFA_TEST_PORTRAIT_HEIGHT_SCALE) / Math.max(SOFA_TEST_PORTRAIT_MAX_HEIGHT_CM, 1);
        artHeight = Math.max(20, Math.round(cappedPortraitHeightCm * portraitPxPerCm));
        artWidth = Math.max(
          20,
          Math.round(artHeight * (proxyDimensions.widthCm / Math.max(proxyDimensions.heightCm, 1)))
        );
      } else if (isSquare) {
        var squareSideCm = Math.min(proxyDimensions.widthCm, proxyDimensions.heightCm);
        var squarePortraitPxPerCm = (safeHeight * SOFA_TEST_PORTRAIT_HEIGHT_SCALE) / Math.max(SOFA_TEST_PORTRAIT_MAX_HEIGHT_CM, 1);
        var squareSidePx = Math.max(20, Math.round(squareSideCm * squarePortraitPxPerCm));
        artWidth = squareSidePx;
        artHeight = squareSidePx;
      } else {
        var sceneScale = Math.min(stageWidth / EXACT_SCENE_SOURCE_SIZE, stageHeight / EXACT_SCENE_SOURCE_SIZE);
        var pxPerCm = sceneScale * (EXACT_SCENE_HEIGHT_PX / 200);
        artWidth = Math.max(20, Math.round(proxyDimensions.widthCm * pxPerCm * SOFA_TEST_SCALE_FACTOR));
        artHeight = Math.max(20, Math.round(proxyDimensions.heightCm * pxPerCm * SOFA_TEST_SCALE_FACTOR));

        if (isLandscape) {
          artWidth = Math.max(20, Math.round(artWidth * SOFA_TEST_LANDSCAPE_BOOST));
          artHeight = Math.max(20, Math.round(artHeight * SOFA_TEST_LANDSCAPE_BOOST));
        }
      }

      if (artWidth > safeWidth || artHeight > safeHeight) {
        var safeFit = Math.min(
          safeWidth / Math.max(artWidth, 1),
          safeHeight / Math.max(artHeight, 1)
        );
        artWidth = Math.max(20, Math.round(artWidth * safeFit));
        artHeight = Math.max(20, Math.round(artHeight * safeFit));
      }

      return {
        width: artWidth,
        height: artHeight,
        left: centerX,
        top: centerY
      };
    }

    function triggerVendorAr() {
      var target = document.getElementById('ar-button') || document.querySelector('[rel="ar"]');
      if (!target) return false;

      if (target.classList) target.classList.add('ar-button--visually-hidden');

      if (typeof target.click === 'function') {
        target.click();
      } else {
        target.dispatchEvent(new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window
        }));
      }

      return true;
    }

    function jumpToVisualiserSlide() {
      if (window.__pdpv3SuppressAutoSlideUntil && Date.now() < window.__pdpv3SuppressAutoSlideUntil) return;
      if (Date.now() < autoSlideReadyAt) return;
      if (document.body && document.body.classList && document.body.classList.contains('page-booting')) return;
      if ((Date.now() - lastTrustedVisualiserInputAt) > 1500) return;
      if (typeof window.__pdpv3SelectVisualiserSlide !== 'function') return;
      if (window.__pdpv3SelectVisualiserSlide()) return;
      window.setTimeout(window.__pdpv3SelectVisualiserSlide, 120);
      window.setTimeout(window.__pdpv3SelectVisualiserSlide, 280);
    }

    function requestSlideIntent(intentKind) {
      if (visualiserFirstExperimentEnabled && typeof window.__pdpv3HandleSlideIntent === 'function') {
        if (window.__pdpv3HandleSlideIntent(intentKind)) return;
      }
      jumpToVisualiserSlide();
    }

    function readState() {
      state.sizeText = getSelectedSizeText();
      state.finishText = getSelectedFinishText();
      state.toneText = getSelectedToneText();
      state.frameText = getSelectedFrameText();
      state.orientationText = getSelectedOrientationText();
      state.orientationPendingImage = false;

      var orientationRaw = (state.orientationText || '').toLowerCase();
      var rawSizeDims = parseSizeTextToCm(state.sizeText);
      if (orientationRaw.indexOf('landscape') !== -1) state.orientation = 'landscape';
      else if (orientationRaw.indexOf('square') !== -1) state.orientation = 'square';
      else if (orientationRaw.indexOf('portrait') !== -1) state.orientation = 'portrait';
      else if (els.artImage && els.artImage.naturalWidth && els.artImage.naturalHeight) {
        state.orientation = inferOrientation(rawSizeDims);
      } else {
        state.orientationPendingImage = true;
      }
    }

    function renderScene() {
      var scene = SCENES[state.scene];
      if (!scene) return;

      root.dataset.scene = state.scene;
      root.dataset.sceneType = ((state.view === 'scale' && SCALE_BACKGROUND_IMAGE) || (state.view !== 'scale' && scene.type === 'image' && scene.image)) ? 'image' : 'css';

      var activeSceneImage = state.view === 'scale' ? SCALE_BACKGROUND_IMAGE : scene.image;
      syncSceneThumb(activeSceneImage);
      var useImageScene = root.dataset.sceneType === 'image' && activeSceneImage;
      var canLoadSceneMedia = isSlideShown();

      if (useImageScene && canLoadSceneMedia) {
        setImageSrcIfChanged(els.sceneImage, activeSceneImage);
        els.sceneImage.style.display = 'block';
        els.sceneImage.style.opacity = '1';
        els.sceneImage.style.visibility = 'visible';
        els.stage.style.backgroundImage = 'url("' + activeSceneImage.replace(/"/g, '\\"') + '")';
        els.stage.style.backgroundSize = 'cover';
        els.stage.style.backgroundPosition = 'center center';
        els.stage.style.backgroundRepeat = 'no-repeat';
      } else if (!useImageScene) {
        els.sceneImage.style.display = 'none';
        els.sceneImage.style.opacity = '0';
        els.sceneImage.style.visibility = 'hidden';
        els.stage.style.removeProperty('background-image');
        els.stage.style.removeProperty('background-size');
        els.stage.style.removeProperty('background-position');
        els.stage.style.removeProperty('background-repeat');
      }
    }

    function renderMeasurements(artLeft, artTop, artWidth, artHeight, dims, stageWidth) {
      var topY = Math.max(24, artTop - 26);
      els.measureLineW.style.left = artLeft + 'px';
      els.measureLineW.style.top = topY + 'px';
      els.measureLineW.style.width = artWidth + 'px';

      els.measureLabelW.textContent = formatValueForDisplay(dims.widthCm, dims.unit) + ' ' + dims.unit;
      els.measureLabelW.style.left = (artLeft + artWidth / 2) + 'px';
      els.measureLabelW.style.top = Math.max(0, topY - 30) + 'px';
      els.measureLabelW.style.transform = 'translate(-50%, 0)';

      var leftX = Math.max(18, artLeft - 22);
      els.measureLineH.style.left = leftX + 'px';
      els.measureLineH.style.top = artTop + 'px';
      els.measureLineH.style.height = artHeight + 'px';

      els.measureLabelH.textContent = formatValueForDisplay(dims.heightCm, dims.unit) + ' ' + dims.unit;
      els.measureLabelH.style.left = Math.max(8, leftX - 76) + 'px';
      els.measureLabelH.style.top = (artTop + artHeight / 2 - 14) + 'px';
      els.measureLabelH.style.transform = 'translate(0, 0)';

      if (artWidth < 160) {
        els.measureLabelW.style.left = Math.min(stageWidth - 72, artLeft + artWidth + 18) + 'px';
        els.measureLabelW.style.top = topY + 'px';
        els.measureLabelW.style.transform = 'translate(0, 0)';
      }
    }

    function getArtImageSrc() {
      if (state.orientation === 'landscape') {
        return PRODUCT_IMAGES.landscape || PRODUCT_IMAGES.fallback || PRODUCT_IMAGES.portrait || PRODUCT_IMAGES.square || '';
      }
      if (state.orientation === 'square') {
        return PRODUCT_IMAGES.square || PRODUCT_IMAGES.fallback || PRODUCT_IMAGES.portrait || PRODUCT_IMAGES.landscape || '';
      }
      return PRODUCT_IMAGES.portrait || PRODUCT_IMAGES.fallback || PRODUCT_IMAGES.landscape || PRODUCT_IMAGES.square || '';
    }

    function parseAgedOverlays() {
      var overlays = [];
      try {
        overlays = JSON.parse(root.dataset.agedOverlays || '[]');
      } catch (error) {
        overlays = [];
      }

      return overlays
        .map(function (overlay) {
          var ratio = Number(overlay && overlay.ratio);
          var src = overlay && overlay.src;
          if (!ratio || !src) return null;
          return { ratio: ratio < 1 ? 1 / ratio : ratio, src: src };
        })
        .filter(Boolean);
    }

    function getOverlayAspectRatio(dimensions) {
      if (dimensions && dimensions.width && dimensions.height) {
        return dimensions.width / Math.max(dimensions.height, 1);
      }

      if (dimensions && dimensions.widthCm && dimensions.heightCm) {
        return dimensions.widthCm / Math.max(dimensions.heightCm, 0.01);
      }

      if (state.orientation === 'landscape') return 1.5;
      if (state.orientation === 'square') return 1;
      return 0.6667;
    }

    function getClosestAgedOverlaySrc(dimensions) {
      var ratio = getOverlayAspectRatio(dimensions);
      var matchingRatio = ratio < 1 ? 1 / ratio : ratio;
      if (AGED_OVERLAYS.length) {
        var closestOverlay = AGED_OVERLAYS.reduce(function (closest, overlay) {
          if (!closest) return overlay;
          return Math.abs(overlay.ratio - matchingRatio) < Math.abs(closest.ratio - matchingRatio) ? overlay : closest;
        }, null);
        return {
          src: closestOverlay.src,
          ratio: closestOverlay.ratio,
          rotate: ratio < 0.98
        };
      }

      var src = ratio > 1.02
        ? root.dataset.overlayLandscape || root.dataset.overlaySquare || root.dataset.overlayPortrait || ''
        : ratio < 0.98
          ? root.dataset.overlayLandscape || root.dataset.overlaySquare || root.dataset.overlayPortrait || ''
          : root.dataset.overlaySquare || root.dataset.overlayLandscape || root.dataset.overlayPortrait || '';
      return {
        src: src,
        ratio: matchingRatio,
        rotate: ratio < 0.98
      };
    }

    function updateAgedOverlay(artWidth, artHeight) {
      var isAged = root.dataset.tone === 'aged';
      if (isAged) {
        var imageRect = els.artImage && els.artImage.getBoundingClientRect ? els.artImage.getBoundingClientRect() : null;
        var fallbackWidth = Number.isFinite(artWidth) ? artWidth : ((els.artImage && els.artImage.clientWidth) || (root.clientWidth * 0.4) || 1);
        var fallbackHeight = Number.isFinite(artHeight) ? artHeight : ((els.artImage && els.artImage.clientHeight) || (root.clientHeight * 0.4) || 1);
        var overlayBox = {
          width: Math.max(1, Math.round(((imageRect && imageRect.width) || fallbackWidth) + 2)),
          height: Math.max(1, Math.round(((imageRect && imageRect.height) || fallbackHeight) + 2))
        };
        var overlay = getClosestAgedOverlaySrc(overlayBox);
        els.agedOverlay.style.setProperty('--pdpv3d-aged-overlay-image', overlay.src ? 'url("' + overlay.src + '")' : 'none');
        els.agedOverlay.dataset.rotate = overlay.rotate ? 'true' : 'false';
        els.agedOverlay.style.setProperty('--pdpv3d-overlay-width', overlayBox.width + 'px');
        els.agedOverlay.style.setProperty('--pdpv3d-overlay-height', overlayBox.height + 'px');
        var boxRatio = overlayBox.width / Math.max(overlayBox.height, 1);
        var normalizedBoxRatio = boxRatio < 1 ? (1 / Math.max(boxRatio, 0.01)) : boxRatio;
        var overlayRatio = Math.max(overlay.ratio || normalizedBoxRatio, 0.01);
        var ratioDelta = Math.abs(normalizedBoxRatio - overlayRatio) / overlayRatio;
        var bgWidth = 100;
        var bgHeight = 100;
        if (ratioDelta > 0.05) {
          var coverScale = Math.max(normalizedBoxRatio / overlayRatio, overlayRatio / normalizedBoxRatio);
          var stretchPercent = Math.max(0, (coverScale - 1) * 100);
          var easedStretchPercent = Math.ceil(stretchPercent * 0.55);
          var adjustedCoverPercent = Math.min(125, 100 + easedStretchPercent);
          if (boxRatio > overlayRatio) {
            bgWidth = adjustedCoverPercent;
          } else {
            bgHeight = adjustedCoverPercent;
          }
        }
        els.agedOverlay.style.setProperty('--pdpv3d-overlay-bg-width', bgWidth + '%');
        els.agedOverlay.style.setProperty('--pdpv3d-overlay-bg-height', bgHeight + '%');
      }
      els.agedOverlay.style.display = isAged ? 'block' : 'none';
    }

    function resetCompareGhost() {
      if (!els.compareGhost) return;
      root.dataset.galleryGhost = 'false';
      root.dataset.galleryGhostTarget = '';
      root.dataset.galleryGhostCurrent = '';
      root.dataset.galleryGhostSize = '';
      els.compareGhost.dataset.hasGhost = 'false';
      els.compareGhost.style.width = '0px';
      els.compareGhost.style.height = '0px';
      els.compareGhost.style.opacity = '0';
    }

    function renderGalleryGhost(currentShellWidth, currentShellHeight, imageRatio, finishKey, stageWidth, stageHeight) {
      if (!els.compareGhost) return;

      var shouldShow = state.view === 'styled' && state.scene === 'sofa';
      var tier = getTierPreviewTarget();
      var target = tier && tier.target;
      if (!shouldShow || !tier || !target || target.input.checked) {
        resetCompareGhost();
        return;
      }

      var galleryDims = target.dims || parseSizeTextToCm(target.value);
      if (!galleryDims) {
        resetCompareGhost();
        return;
      }
      var currentDims = parseSizeTextToCm(state.sizeText);
      var currentArea = currentDims ? (currentDims.widthCm * currentDims.heightCm) : 0;
      var targetArea = galleryDims.widthCm * galleryDims.heightCm;
      var label = els.compareGhost.querySelector('.pdpv3d-compare-ghost-label');
      root.dataset.galleryGhostTarget = target.value;
      root.dataset.galleryGhostCurrent = state.sizeText || '';

      if (targetArea <= currentArea) {
        resetCompareGhost();
        return;
      }
      var targetMeasurementDims = state.view === 'scale'
        ? (orientDims(galleryDims, getOrientationFromRenderedRatio(imageRatio, galleryDims)) || galleryDims)
        : galleryDims;
      var targetProxy = getProxyDimensionsCm(targetMeasurementDims, imageRatio);
      if (!targetProxy) {
        resetCompareGhost();
        return;
      }

      var targetPlacement = state.view === 'scale'
        ? getExactScalePlacement(targetMeasurementDims, targetProxy, stageWidth, stageHeight, finishKey)
        : state.scene === 'sofa'
          ? getSofaTestPlacement(targetProxy, stageWidth, stageHeight)
          : getStyledScenePlacement(state.scene, targetProxy, galleryDims, stageWidth, stageHeight);
      var targetPixels = targetPlacement || getArtPixels(targetProxy, targetMeasurementDims, stageWidth, stageHeight, state.view, state.scene);
      if (!targetPixels || !targetPixels.width || !targetPixels.height) {
        resetCompareGhost();
        return;
      }

      var targetFrameThicknessPx = finishKey === 'framed'
        ? getFrameThicknessPx(targetProxy, targetPixels, galleryDims.unit)
        : 0;
      var ghostWidth = Math.round(targetPixels.width + (targetFrameThicknessPx * 2));
      var ghostHeight = Math.round(targetPixels.height + (targetFrameThicknessPx * 2));

      ghostWidth = Math.max(ghostWidth, currentShellWidth + 18);
      ghostHeight = Math.max(ghostHeight, currentShellHeight + 18);

      root.dataset.galleryGhost = 'true';
      root.dataset.galleryGhostSize = ghostWidth + 'x' + ghostHeight;
      els.compareGhost.dataset.hasGhost = 'true';
      els.compareGhost.style.width = ghostWidth + 'px';
      els.compareGhost.style.height = ghostHeight + 'px';
      els.compareGhost.style.opacity = '1';
      if (label) label.textContent = tier.label;
      els.compareGhost.setAttribute('aria-label', tier.label);
    }

    function canRenderNow() {
      if (document.visibilityState === 'hidden') return false;
      if (!isRootInViewport()) return false;
      if (visualiserSlide && !isSlideShown()) return false;
      return true;
    }

    function flushDeferredRender() {
      if (!pendingOffscreenRender) return;
      if (!canRenderNow()) return;
      pendingOffscreenRender = false;
      render(false);
    }

    function requestRender(force) {
      if (force === true) {
        pendingOffscreenRender = false;
        render(true);
        return;
      }
      if (!canRenderNow()) {
        pendingOffscreenRender = true;
        return;
      }
      pendingOffscreenRender = false;
      render(false);
    }

    function render(force) {
      var forceRender = force === true;
      if (!forceRender && !canRenderNow()) {
        pendingOffscreenRender = true;
        return;
      }
      readState();
      resetCompareGhost();
      root.dataset.ghostReady = 'true';

      if (state.orientationPendingImage) {
        var pendingSrc = getArtImageSrc();
        setImageSrcIfChanged(els.artImage, pendingSrc);
        if (initOrientationRetryCount < 8) {
          initOrientationRetryCount += 1;
          window.setTimeout(render, [60, 120, 200, 320, 500, 750, 1050, 1400][initOrientationRetryCount - 1]);
        }
        return;
      }
      initOrientationRetryCount = 0;

      root.dataset.tone = normaliseToneKey(state.toneText);
      syncFinishSwitch();
      syncToneSwitch();

      var dims = parseSizeTextToCm(state.sizeText);
      if (!dims) {
        if (initStateRetryCount < 6) {
          initStateRetryCount += 1;
          window.setTimeout(render, [80, 160, 280, 450, 700, 1000][initStateRetryCount - 1]);
        }
        renderScene();
        var earlyArtSrc = getArtImageSrc();
        if (earlyArtSrc) {
          setImageSrcIfChanged(els.artImage, earlyArtSrc);
          els.artImage.style.opacity = '1';
          els.artImage.style.visibility = 'visible';
          els.artImage.style.display = 'block';
        }
        updateAgedOverlay();
        return;
      }
      initStateRetryCount = 0;
      var physicalDims = state.view === 'scale'
        ? orientDims(dims, inferOrientation(dims))
        : dims;
      if (!physicalDims) return;

      var finishRaw = (state.finishText || '').toLowerCase();
      var finishKey = 'unframed';
      if (finishRaw.indexOf('canvas') !== -1) finishKey = 'canvas';
      else if (finishRaw.indexOf('fram') !== -1) finishKey = 'framed';

      root.dataset.view = state.view;
      root.dataset.finish = finishKey;
      renderScene();

      var artSrc = getArtImageSrc();
      if (artSrc) {
        setImageSrcIfChanged(els.artImage, artSrc);
        els.artImage.style.opacity = '1';
        els.artImage.style.visibility = 'visible';
        els.artImage.style.display = 'block';
      }

      var outerDims = getOuterDims(dims, finishKey);
      var metaText = formatSizeTextForMeta(state.sizeText);
      if ((finishKey === 'framed' || finishKey === 'canvas') && outerDims) {
        metaText = (formatFramedSizeForMeta(state.sizeText) || formatDims(outerDims.widthCm, outerDims.heightCm, outerDims.unit)) + ' (incl. frame)';
      }
      els.meta.textContent = metaText;

      var stageRect = els.stage.getBoundingClientRect();
      var stageWidth = stageRect.width || root.clientWidth || 640;
      var stageHeight = stageRect.height || root.clientHeight || 640;
      var imageRatio = getSourceImageAspectRatio() || 0.75;
      var proxy = getProxyDimensionsCm(physicalDims, imageRatio);
      if (!proxy) return;
      var measurementDims = physicalDims;
      if (state.view === 'scale') {
        measurementDims = orientDims(dims, getOrientationFromRenderedRatio(imageRatio, dims)) || physicalDims;
      }
      var labelDims = measurementDims;
      if (state.view === 'scale' && (finishKey === 'framed' || finishKey === 'canvas') && outerDims) {
        labelDims = orientDims(outerDims, getOrientationFromRenderedRatio(imageRatio, outerDims)) || outerDims;
      }

      var artPlacement = state.view === 'scale'
        ? getExactScalePlacement(measurementDims, proxy, stageWidth, stageHeight, finishKey)
        : state.scene === 'sofa'
          ? getSofaTestPlacement(proxy, stageWidth, stageHeight)
          : getStyledScenePlacement(state.scene, proxy, dims, stageWidth, stageHeight);
      var artPixels = artPlacement || getArtPixels(proxy, physicalDims, stageWidth, stageHeight, state.view, state.scene);
      var artWidth = artPixels.width;
      var artHeight = artPixels.height;

      var artLeft = artPlacement ? artPlacement.left : stageWidth * 0.50;
      var defaultTopBase = stageHeight * 0.34;
      var defaultTopMax = stageHeight * 0.46;
      if (state.view === 'styled' && state.scene === 'sofa') {
        var sofaPortrait = proxy.heightCm > proxy.widthCm * 1.05;
        defaultTopBase = sofaPortrait ? stageHeight * 0.30 : stageHeight * 0.30;
        defaultTopMax = sofaPortrait ? stageHeight * 0.35 : stageHeight * 0.37;
      }
      var artTop = artPlacement
        ? artPlacement.top
        : clamp(defaultTopBase, artHeight / 2 + 18, defaultTopMax);

      var frameThicknessPx = (finishKey === 'framed' || finishKey === 'canvas') ? getFrameThicknessPx(proxy, artPixels, dims.unit) : 0;
      var shellWidth = artWidth + (frameThicknessPx * 2);
      var shellHeight = artHeight + (frameThicknessPx * 2);

      root.style.setProperty('--pdpv3d-art-left', artLeft + 'px');
      root.style.setProperty('--pdpv3d-art-top', artTop + 'px');
      root.style.setProperty('--pdpv3d-art-width', shellWidth + 'px');
      root.style.setProperty('--pdpv3d-art-height', shellHeight + 'px');
      root.style.setProperty('--pdpv3d-art-translate-x', '-50%');
      root.style.setProperty('--pdpv3d-art-translate-y', '-50%');
      var resolvedFrameColor = resolveFrameColor(state.frameText);
      root.style.setProperty('--pdpv3d-frame-color', resolvedFrameColor);
      root.style.setProperty(
        '--pdpv3d-frame-thickness',
        frameThicknessPx + 'px'
      );
      syncThumbArtworkPlacement(artLeft, artTop, artWidth, artHeight, stageWidth, stageHeight);
      updateAgedOverlay(artWidth, artHeight);

      var dropShadow = '7px 22px 31px rgba(0, 0, 0, 0.115)';
      var ambientShadow = '0 6px 14px rgba(0, 0, 0, 0.038)';
      var frameHighlight = 'rgba(255, 255, 255, 0.14)';
      var frameInnerShadow = 'rgba(0, 0, 0, 0.125)';
      var paperEdge = 'rgba(255, 255, 255, 0.20)';
      var paperSheenOpacity = finishKey === 'framed' ? '0.07' : '0.045';
      var contactShadowOpacity = '0.42';
      var contactShadowBlur = '16px';
      var canvasEdgeSize = '0px';
      var canvasEdgeHighlight = 'rgba(255, 255, 255, 0)';
      var canvasEdgeShadow = 'rgba(0, 0, 0, 0)';
      var wrapShadow = finishKey === 'framed'
        ? '8px 24px 34px rgba(0, 0, 0, 0.105), 0 6px 16px rgba(0, 0, 0, 0.034)'
        : '6px 20px 28px rgba(0, 0, 0, 0.088), 0 5px 14px rgba(0, 0, 0, 0.03)';

      if (state.view === 'scale') {
        dropShadow = finishKey === 'framed'
          ? '3px 12px 16px rgba(58, 43, 28, 0.075)'
          : '2px 10px 14px rgba(58, 43, 28, 0.062)';
        ambientShadow = '0 4px 10px rgba(0, 0, 0, 0.024)';
        wrapShadow = finishKey === 'framed'
          ? '4px 14px 18px rgba(58, 43, 28, 0.07), 0 4px 10px rgba(0, 0, 0, 0.026)'
          : '3px 12px 16px rgba(58, 43, 28, 0.053), 0 3px 8px rgba(0, 0, 0, 0.022)';
        frameHighlight = 'rgba(255, 255, 255, 0.105)';
        frameInnerShadow = 'rgba(0, 0, 0, 0.10)';
        paperEdge = 'rgba(255, 255, 255, 0.17)';
        paperSheenOpacity = finishKey === 'framed' ? '0.045' : '0.03';
        contactShadowOpacity = '0.28';
        contactShadowBlur = '18px';
      } else if (state.scene === 'gallery') {
        dropShadow = finishKey === 'framed'
          ? '5px 18px 27px rgba(82, 60, 34, 0.128)'
          : '4px 16px 23px rgba(82, 60, 34, 0.098)';
        ambientShadow = '0 5px 12px rgba(61, 44, 23, 0.034)';
        frameHighlight = 'rgba(255, 250, 239, 0.19)';
        frameInnerShadow = 'rgba(72, 50, 24, 0.125)';
        paperEdge = 'rgba(255, 250, 239, 0.22)';
        wrapShadow = finishKey === 'framed'
          ? '6px 20px 30px rgba(86, 63, 35, 0.122), 0 5px 14px rgba(44, 29, 12, 0.034)'
          : '5px 16px 24px rgba(86, 63, 35, 0.088), 0 4px 12px rgba(44, 29, 12, 0.03)';
        paperSheenOpacity = finishKey === 'framed' ? '0.075' : '0.05';
        contactShadowOpacity = '0.38';
        contactShadowBlur = '17px';
      } else if (state.scene === 'charcoal') {
        dropShadow = finishKey === 'framed'
          ? '8px 24px 36px rgba(0, 0, 0, 0.19)'
          : '6px 19px 28px rgba(0, 0, 0, 0.148)';
        ambientShadow = '0 6px 14px rgba(0, 0, 0, 0.064)';
        frameHighlight = 'rgba(255, 245, 232, 0.11)';
        frameInnerShadow = 'rgba(0, 0, 0, 0.20)';
        paperEdge = 'rgba(255, 245, 232, 0.14)';
        paperSheenOpacity = finishKey === 'framed' ? '0.05' : '0.03';
        wrapShadow = finishKey === 'framed'
          ? '9px 28px 38px rgba(0, 0, 0, 0.175), 0 6px 16px rgba(0, 0, 0, 0.068)'
          : '7px 22px 32px rgba(0, 0, 0, 0.132), 0 5px 14px rgba(0, 0, 0, 0.055)';
        contactShadowOpacity = '0.34';
        contactShadowBlur = '18px';
      }

      if (finishKey === 'unframed') {
        dropShadow = '0 0 0 rgba(0, 0, 0, 0)';
        ambientShadow = '0 0 0 rgba(0, 0, 0, 0)';
        wrapShadow = 'none';
        paperEdge = 'rgba(255, 255, 255, 0)';
        paperSheenOpacity = '0';
        contactShadowOpacity = '0';
        contactShadowBlur = '0px';
      } else if (finishKey === 'canvas') {
        dropShadow = '0 8px 14px rgba(0, 0, 0, 0.16)';
        ambientShadow = '0 22px 36px rgba(0, 0, 0, 0.10)';
        wrapShadow = '0 2px 4px rgba(0, 0, 0, 0.07), 0 16px 28px rgba(0, 0, 0, 0.10)';
        paperEdge = 'rgba(255, 255, 255, 0.10)';
        paperSheenOpacity = '0.02';
        contactShadowOpacity = '0.48';
        contactShadowBlur = '20px';
        canvasEdgeSize = '10px';
        canvasEdgeHighlight = 'rgba(255, 255, 255, 0.15)';
        canvasEdgeShadow = 'rgba(0, 0, 0, 0.14)';

        if (state.view === 'scale') {
          dropShadow = '0 6px 10px rgba(58, 43, 28, 0.10)';
          ambientShadow = '0 12px 18px rgba(58, 43, 28, 0.07)';
          wrapShadow = '0 1px 3px rgba(58, 43, 28, 0.05), 0 10px 18px rgba(58, 43, 28, 0.08)';
          contactShadowOpacity = '0.30';
          contactShadowBlur = '18px';
          canvasEdgeSize = '8px';
        } else if (state.scene === 'gallery') {
          dropShadow = '0 8px 14px rgba(86, 63, 35, 0.15)';
          ambientShadow = '0 20px 34px rgba(86, 63, 35, 0.12)';
          wrapShadow = '0 2px 4px rgba(44, 29, 12, 0.06), 0 14px 26px rgba(86, 63, 35, 0.11)';
        } else if (state.scene === 'charcoal') {
          dropShadow = '0 10px 18px rgba(0, 0, 0, 0.20)';
          ambientShadow = '0 26px 40px rgba(0, 0, 0, 0.16)';
          wrapShadow = '0 3px 6px rgba(0, 0, 0, 0.08), 0 18px 32px rgba(0, 0, 0, 0.14)';
          paperEdge = 'rgba(255, 245, 232, 0.08)';
          canvasEdgeHighlight = 'rgba(255, 245, 232, 0.10)';
        }
      }

      root.style.setProperty('--pdpv3d-art-drop-shadow', dropShadow);
      root.style.setProperty('--pdpv3d-art-ambient-shadow', ambientShadow);
      root.style.setProperty('--pdpv3d-shadow', wrapShadow);
      root.style.setProperty('--pdpv3d-frame-highlight', frameHighlight);
      root.style.setProperty('--pdpv3d-frame-inner-shadow', frameInnerShadow);
      root.style.setProperty('--pdpv3d-paper-edge', paperEdge);
      root.style.setProperty('--pdpv3d-paper-sheen-opacity', paperSheenOpacity);
      root.style.setProperty('--pdpv3d-contact-shadow-opacity', contactShadowOpacity);
      root.style.setProperty('--pdpv3d-contact-shadow-blur', contactShadowBlur);
      root.style.setProperty('--pdpv3d-canvas-edge-size', canvasEdgeSize);
      root.style.setProperty('--pdpv3d-canvas-edge-highlight', canvasEdgeHighlight);
      root.style.setProperty('--pdpv3d-canvas-edge-shadow', canvasEdgeShadow);

      if (state.view === 'styled') {
        if (state.scene === 'sofa') {
          root.style.setProperty('--pdpv3d-art-translate-y', 'calc(-50% + 1px)');
        } else if (state.scene === 'gallery') {
          root.style.setProperty('--pdpv3d-art-translate-x', 'calc(-50% - 0.5px)');
          root.style.setProperty('--pdpv3d-art-translate-y', 'calc(-50% + 0.5px)');
        } else if (state.scene === 'charcoal') {
          root.style.setProperty('--pdpv3d-art-translate-x', 'calc(-50% - 0.5px)');
          root.style.setProperty('--pdpv3d-art-translate-y', 'calc(-50% + 1px)');
        }
      }

      renderMeasurements(
        artLeft - artWidth / 2,
        artTop - artHeight / 2,
        artWidth,
        artHeight,
        labelDims,
        stageWidth
      );

      renderGalleryGhost(shellWidth, shellHeight, imageRatio, finishKey, stageWidth, stageHeight);
      root.dataset.desktopVisualiserMounted = 'true';

      root.querySelectorAll('[data-scene-btn]').forEach(function (item) {
        var key = item.dataset.sceneBtn;
        var isActive = key === 'scale'
          ? state.view === 'scale'
          : state.view === 'styled' && state.scene === key;
        item.classList.toggle('is-active', isActive);
      });
    }

    root.querySelectorAll('[data-view-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        holdStickyOpen();
        state.view = btn.dataset.viewBtn === 'scale' ? 'scale' : 'styled';
        root.querySelectorAll('[data-view-btn]').forEach(function (item) {
          item.classList.toggle('is-active', item === btn);
        });
        requestRender(true);
      });
    });

    root.querySelectorAll('[data-scene-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        holdStickyOpen();
        var next = btn.dataset.sceneBtn;
        if (!ENABLE_BLANKWALL_SCENE && next === 'blankwall') return;
        if (next === 'scale') {
          state.view = 'scale';
        } else {
          state.view = 'styled';
          state.scene = next;
        }
        requestRender(true);
      });
    });

    if (els.meta) {
      els.meta.addEventListener('click', function (event) {
        event.preventDefault();
        holdStickyOpen();
        scrollSizeFieldsetIntoView();
      });
    }

    if (els.arButton) {
      els.arButton.addEventListener('click', function (event) {
        event.preventDefault();
        if (triggerVendorAr()) return;
        window.setTimeout(triggerVendorAr, 250);
      });
    }

    if (els.zoomButton) {
      els.zoomButton.addEventListener('click', function (event) {
        if (!(state.view === 'styled' && state.scene === 'blankwall')) return;
        holdStickyOpen();
        if (tryOpenSuperZoomFromVisualiser()) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);
    }

    if (els.compareGhost) {
      els.compareGhost.addEventListener('click', function (event) {
        event.preventDefault();
        holdStickyOpen();
        if (state.scene === 'blankwall') return;
        var tier = getTierPreviewTarget();
        if (tier && tier.target) {
          window.__pdpv3SuppressAutoSlideUntil = Date.now() + 900;
          window.__pdpv3SuppressStickyRedirectUntil = Date.now() + 1200;
          activateSizeInput(tier.target.input, { preventLabelClick: true });
        }
      });
    }

    var rerender = debounce(function () {
      requestRender();
    }, 80);

    document.querySelectorAll(
      'fieldset[name="Size"] input, fieldset[name="Finish"] input, fieldset[name="Portrait or landscape?"] input'
    ).forEach(function (el) {
      el.addEventListener('change', function () {
        requestSlideIntent(isSizeVariantControl(el) ? 'size' : 'variant');
        rerender();
      });
      el.addEventListener('click', function () {
        requestSlideIntent(isSizeVariantControl(el) ? 'size' : 'variant');
        window.setTimeout(rerender, 80);
      });
    });

    function isVisualiserVariantControl(el) {
      var wrap = el && el.closest && el.closest('.variant-wrapper, .variant-input-wrap, fieldset');
      var name = String((wrap && wrap.getAttribute('name')) || '').trim().toLowerCase();
      var handle = String((wrap && wrap.dataset && wrap.dataset.handle) || '').trim().toLowerCase();
      return name === 'size' || name === 'finish' || name === 'finition' || name === 'portrait or landscape?' || handle === 'size' || handle === 'finish' || handle === 'finition';
    }

    function isSizeVariantControl(el) {
      var wrap = el && el.closest && el.closest('.variant-wrapper, .variant-input-wrap, fieldset');
      var name = String((wrap && wrap.getAttribute('name')) || '').trim().toLowerCase();
      var handle = String((wrap && wrap.dataset && wrap.dataset.handle) || '').trim().toLowerCase();
      return name === 'size' || handle === 'size';
    }

    function isVisualiserInputIntent(el) {
      return isVisualiserVariantControl(el) || !!(el && el.closest && el.closest('[data-featured-size-key], div.option_colour_tone, div.option_frame_colour_new, .option_colour_tone, .option_frame_colour_new'));
    }

    document.querySelectorAll('.variant-input--pseudo, .variant-input--pseudo .pseudo-button, label.variant__button-label').forEach(function (el) {
      el.addEventListener('click', function () {
        if (!isVisualiserVariantControl(el)) return;
        requestSlideIntent(isSizeVariantControl(el) ? 'size' : 'variant');
      });
    });

    document.addEventListener('click', function (event) {
      var featuredSizeButton = event.target && event.target.closest
        ? event.target.closest('[data-featured-size-key][data-size-value]')
        : null;
      if (!featuredSizeButton) return;
      requestSlideIntent('size');
      rerender();
      window.setTimeout(rerender, 120);
      window.setTimeout(rerender, 280);
    }, true);

    document.querySelectorAll('div.option_colour_tone input, div.option_frame_colour_new input').forEach(function (el) {
      el.addEventListener('change', function () {
        requestSlideIntent('variant');
        rerender();
        scheduleOptionRerender();
      });
      el.addEventListener('click', function () {
        requestSlideIntent('variant');
        scheduleOptionRerender();
      });
    });

    document.querySelectorAll('div.option_colour_tone, div.option_frame_colour_new').forEach(function (el) {
      el.addEventListener('click', function () {
        requestSlideIntent('variant');
        scheduleOptionRerender();
      });
    });

    if (typeof MutationObserver !== 'undefined') {
      var optionObserverTargets = document.querySelectorAll(
        'div.option_colour_tone, .option_colour_tone, div.option_frame_colour_new, .option_frame_colour_new, .option_frame_colour, .option_frame_colour_canvas'
      );
      optionObserverTargets.forEach(function (target) {
        var observer = new MutationObserver(function () {
          scheduleOptionRerender();
        });
        observer.observe(target, {
          subtree: true,
          childList: true,
          attributes: false
        });
      });
    }

    document.addEventListener('change', function (event) {
      var target = event.target;
      if (!target || !target.matches) return;
      if (
        target.matches('input[name="properties[Colour tone]"]') ||
        target.matches('input[name="properties[Frame colour]"]')
      ) {
        requestSlideIntent('variant');
        scheduleOptionRerender();
      }
    });

    document.addEventListener('variant:change', function () {
      rerender();
      window.setTimeout(rerender, 120);
    });

    window.addEventListener('resize', rerender);
    if (els.artImage) els.artImage.addEventListener('load', rerender);
    if (els.sceneImage) els.sceneImage.addEventListener('load', rerender);

    var visualiserSlide = root.closest ? root.closest('.product-main-slide') : null;
    function isSlideShown() {
      if (!visualiserSlide) return true;
      if (visualiserSlide.getAttribute('aria-hidden') === 'true') return false;
      return visualiserSlide.classList.contains('is-selected');
    }
    function isRootInViewport() {
      var anchor = (root && root.closest && root.closest('.product__main-photos')) || root;
      if (!anchor || !anchor.getBoundingClientRect) return true;
      var rect = anchor.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
      var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
      return rect.width > 0 &&
        rect.height > 0 &&
        rect.bottom > 0 &&
        rect.right > 0 &&
        rect.top < viewportHeight &&
        rect.left < viewportWidth;
    }
    function scheduleShownRenders() {
      [0, 160, 420].forEach(function (delay) {
        window.setTimeout(function () {
          requestRender();
        }, delay);
      });
    }

    function bindFlickityRenderHook() {
      var carousel = document.querySelector('.product-slideshow');
      if (!carousel || !(window.Flickity && window.Flickity.data)) return false;
      var flkty = window.Flickity.data(carousel);
      if (!flkty || typeof flkty.on !== 'function' || typeof flkty.getCellElements !== 'function') return false;
      if (!visualiserSlide) return false;

      var slideCellIndex = -1;
      var cells = flkty.getCellElements() || [];
      for (var i = 0; i < cells.length; i += 1) {
        if (cells[i] === visualiserSlide) {
          slideCellIndex = i;
          break;
        }
      }
      if (slideCellIndex < 0) return false;

      function onSelect(index) {
        if (Number(index) !== slideCellIndex) return;
        requestRender();
        window.setTimeout(requestRender, 120);
      }

      flkty.on('select', onSelect);
      flkty.on('settle', onSelect);
      return true;
    }
    if (visualiserSlide && typeof MutationObserver !== 'undefined') {
      var wasShown = isSlideShown();
      var slideObserver = new MutationObserver(function () {
        var shown = isSlideShown();
        if (shown && !wasShown) {
          scheduleShownRenders();
        }
        wasShown = shown;
      });
      slideObserver.observe(visualiserSlide, {
        attributes: true,
        attributeFilter: ['class', 'aria-hidden']
      });
    }

    if ('IntersectionObserver' in window) {
      var renderVisibilityObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          flushDeferredRender();
        });
      }, { threshold: 0.02 });
      renderVisibilityObserver.observe(root);
    }

    (function tryBindFlickityHook(attempt) {
      if (bindFlickityRenderHook()) return;
      if (attempt >= 12) return;
      window.setTimeout(function () {
        tryBindFlickityHook(attempt + 1);
      }, 180);
    })(0);

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState !== 'visible') return;
      window.setTimeout(flushDeferredRender, 40);
    });

    root.addEventListener('pdpv3:force-render', function () {
      requestRender(true);
    });

    requestRender();
  });
})();
